<template>
    <div id="app">
        <header :style="'top: 0;' + (((logged || isGuest) && (!modal_cadastro_ && !modal_login_))? 'z-index:998' : '')"
                ref="header-main"
                v-if="(!template_html || template_html.header_default_enable)">
            <div v-if="!this.logged && !this.isGuest && this.switch.without_landing_page != 'without_landing_page'"
                 class="menu">
                <div class="menu__home" ref="menuHome">
                    <div class="container-header">
                        <img
                            v-if="(access_before_start.includes($route.name) && $route.name!=='Support') && this.$refs['main'] && logo_"
                            ref="logo" :src="logo_" alt="Logo" @error="errorImage"/>
                        <img v-else-if="logo_" style="cursor: pointer" v-on:click="link('Home')" ref="logo" :src="logo_"
                             alt="Logo"
                             @error="errorImage"/>
                        <div class="container-header-button">
                            <div class="container-header-button btn-mobile" v-if='$route.name!="PublicRanking"'>
                                <div v-if="this.switch.login_signup" v-on:click="modal_cadastro_ = true"
                                     class="header-button">
                                    <a ref="btn-cadastro-header">
                                        <a v-html="this.$i18n.t('home.criarMinhaConta')"></a>
                                    </a>
                                </div>
                                <div v-if="this.switch.guest_mode" v-on:click="createGuestVerifyCaptcha()"
                                     class="header-button">
                                    <a ref="btn-guest-header">
                                        <a v-html="this.$i18n.t('home.entrarVisitante')"></a>
                                    </a>
                                </div>
                                <div v-if="this.switch.login_signup" v-on:click="modal_login_ = true" class="signin">
                                    <a ref="btn-login-header">
                                        <a v-html="this.$i18n.t('home.jaSouCadastrado')"></a>
                                    </a>
                                </div>
                                <div v-else>
                                    <div v-show="!webview" style="position: relative;gap: 5px;justify-content: center;align-items: center;height: 100%;margin-top: 0;" class="modals__content-social-medias flex">
                                        <span :style="{color:'var(--buttons_color)'}" v-if="this.switch.Login_Gmail || this.switch.Login_Facebook || this.switch.Login_Azure" v-html="this.$i18n.t('home.logarCom')"></span>
                                        <LoginGoogle v-if="this.switch.Login_Gmail" origin="home"></LoginGoogle>
                                        <LoginFacebook v-if="this.switch.Login_Facebook" origin="home" ></LoginFacebook>
                                        <LoginAzure v-if="this.switch.Login_Azure" origin="home"></LoginAzure>
                                    </div>
                                </div>
                            </div>
                            <div class="iconLanguage alignVertical" v-if="this.switch.multilanguages">
                                <v-select ref="localeSelect" v-model="$i18n.locale" @input="setLocale"
                                            :options="options"  :searchable="false" :reduce="option => option.code" :clearable="false">
                                    <template #open-indicator="{ }">

                                    </template>
                                    <template #selected-option="{  }">
                                        <div v-html="header_buttons.language_button"></div>
                                    </template>

                                    <template slot="option" slot-scope="option" v-if="option.active">
                                        <img style="margin:0px" width="20px" :src="option.icon" />
                                    </template>
                                </v-select>
                            </div>
                            <div v-on:click="link('Support')" class="iconAjuda alignVertical cursor-pointer"
                                 :title="descs.help.description" :style="isMobile ? { marginRight: '8px'} : ''" v-if='$route.name!="PublicRanking"'>
                                <div v-html="this.header_buttons.help_button"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.logged || this.isGuest" class="menu logged">
              <div v-if="isLms">
                <LmsHeader></LmsHeader>
              </div>

              <div v-else class="menu__map menu__bgHeader" ref="menuHome">
                    <div class="menu__map--content flex flex-wrap">
                        <div class="menu__map--content---logos alignVerticalStart">
                            <div v-on:click="tools = !tools">
                                <img class="menu__map--content---logos--menuImage" src="assets/icons/header/black/menu.png"
                                     alt="menu-lateral"/>
                            </div>
                            <img v-if="logo_" id="logomap" style="cursor:pointer;"
                                 v-on:click="mobileClose();redirectToMap();"
                                 ref="logo" :src="logo_"
                                 @error="errorImage" alt="Logo" :title="descs.logo.description">
                            <div :class="'infos flex flex-wrap alignVerticalEnd ' +(this.$route.name == 'Map' ? 'blueHeader' : '')">
                                <div v-if="!this.isGuest && this.isMobile && !this.switch.btn_promotional.active" v-on:click="exitLocal(profileExit)">
                                    <div class="alignVertical" id="nick">
                                        <span style="cursor:pointer; margin: 0 0 0 auto !important;" id="user-name"
                                                ref="user-name" :title="descs.nick.description">
                                            <p :class="'text-nickname' + ( (this.switch.event_menu.score_moedas && this.switch.coins_on_header) || (this.switch.event_menu.score_pontos && this.switch.points_on_header) ? ' ellipsed' : '')">{{ nickname }}</p>
                                        </span>
                                    </div>
                                </div>
                                <div v-else-if="this.isGuest && this.isMobile && !this.switch.btn_promotional.active" v-on:click="modal_cadastro_ = true">
                                    <div v-if="Boolean(this.switch.guest_mode) && this.switch.login_signup">
                                        <div class="alignVertical" id="nick">
                                            <span style="cursor:pointer; margin: 0 0 0 auto !important;" id="user-name"
                                                    ref="user-name" :title="descs.guest.description">
                                                <p class="'text-nickname' + ( (this.switch.event_menu.score_moedas && this.switch.coins_on_header) || (this.switch.event_menu.score_pontos && this.switch.points_on_header) ? ' ellipsed' : '')" style="text-decoration: underline">{{ this.$i18n.t('guest.criarConta') }}</p>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            <div v-if="this.isMobile && !this.switch.btn_promotional.active">
                            <div id="pointsIsMobile" v-if="(this.switch.Habilitar_Pontos && this.switch.points_on_header) || (this.switch.Habilitar_Moedas && this.switch.coins_on_header)" class="points">
                                <div v-if="this.switch.enable_badge_counter">
                                    <div style="margin-right: 10px; padding-right: 5px;" id="badgeCounter" v-if="this.switch.enable_badge_counter"
                                            class="alignVerticalEnd moeda-total"
                                            v-on:click="redirectTo('badges')" :title="descs.badges.description">
                                        <p style="align-items: center;">{{ TotalBadges }}</p>
                                        <div v-html="this.header_buttons.badges_button"></div>
                                    </div>
                                </div>
                                <div v-if="this.switch.event_menu && this.switch.event_menu['score_pontos']">
                                    <div style="margin-right: 10px; padding-right: 5px;" id="point" v-if="this.switch.Habilitar_Pontos && this.switch.points_on_header"
                                             class="alignVerticalEnd moeda-total"
                                             v-on:click="exitLocal(pointsExit)" :title="descs.points.description">
                                            <p style="align-items: center;">{{ TotalPoints }}</p>
                                            <div v-html="this.header_buttons.points_button"></div>
                                    </div>

                                </div>
                                    <div v-if="this.switch.event_menu && this.switch.event_menu['score_moedas']">
                                        <div style="margin-risMobileight: 10px; padding-right: 5px;" id="coin" v-if="this.switch.Habilitar_Moedas && this.switch.coins_on_header"
                                             class="alignVerticalEnd ponto-total" v-on:click="openPackage"
                                             >
                                            <p>{{ TotalCoins }}</p>
                                            <div v-html="this.header_buttons.coins_button"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="this.isMobile && this.switch.btn_promotional.active" style="width: 360px;">
                                <BtnPromotional v-if="this.switch.btn_promotional.active && !this.isGuest"/>
                            </div>
                        </div>
                        </div>

                        <div class="menu__map--content---mapMenu alignVerticalEnd ">
                            <div
                                :class="'infos flex flex-wrap alignVerticalEnd ' +(this.$route.name == 'Map' ? 'blueHeader' : '')">
                                <div v-if="!this.isGuest && (!this.isMobile || this.switch.btn_promotional.active)" v-on:click="exitLocal(profileExit)">
                                    <div class="alignVertical" id="nick">
                                        <span style="cursor:pointer; margin: 0 0 0 auto !important;" id="user-name"
                                              ref="user-name" :title="descs.nick.description">
                                            <p class="text-nickname">{{ nickname }}</p>
                                        </span>
                                    </div>
                                </div>
                                <div v-if="this.isGuest && (!this.isMobile || this.switch.btn_promotional.active)" v-on:click="modal_cadastro_ = true">
                                    <div v-if="Boolean(this.switch.guest_mode) && this.switch.login_signup">
                                        <div class="alignVertical" id="nick">
                                            <span style="cursor:pointer; margin: 0 0 0 auto !important;" id="user-name"
                                                  ref="user-name" :title="descs.guest.description">
                                                <p class="text-nickname">{{ this.$i18n.t('guest.criarConta') }}</p>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="!this.isGuest && this.isMobile && !this.switch.btn_promotional.active" v-on:click="exitLocal(profileExit)">
                                    <div class="alignVertical" id="nick">
                                        <span style="cursor:pointer; margin: 0 0 0 auto !important; font-size: 16px !important" id="user-name"
                                                ref="user-name" :title="descs.nick.description">
                                            <p class="text-nickname">{{ nickname }}</p>
                                        </span>
                                    </div>
                                </div>
                                <div v-else-if="this.isGuest && this.isMobile" v-on:click="modal_cadastro_ = true">
                                    <div v-if="Boolean(this.switch.guest_mode) && this.switch.login_signup">
                                        <div class="alignVertical" id="nick">
                                            <span style="cursor:pointer; margin: 0 0 0 auto !important; font-size: 16px !important" id="user-name"
                                                    ref="user-name" :title="descs.guest.description">
                                                <p class="text-nickname">{{ this.$i18n.t('guest.criarConta') }}</p>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="!this.isMobile && ((this.switch.Habilitar_Pontos && this.switch.points_on_header) || (this.switch.Habilitar_Moedas && this.switch.coins_on_header) || this.switch.enable_badge_counter)" class="points">
                                    <div v-if="this.switch.enable_badge_counter">
                                        <div style="margin-right: 10px; padding-right: 5px;" id="badgeCounter" v-if="this.switch.enable_badge_counter"
                                             class="alignVerticalEnd moeda-total"
                                             v-on:click="redirectTo('badges')" :title="descs.badges.description">
                                            <p>{{ TotalBadges }}</p>
                                            <div v-html="this.header_buttons.badges_button"></div>
                                        </div>
                                    </div>
                                    <div v-if="this.switch.event_menu && this.switch.event_menu['score_pontos']">
                                        <div style="margin-right: 10px; padding-right: 5px;" id="point" v-if="this.switch.Habilitar_Pontos && this.switch.points_on_header"
                                             class="alignVerticalEnd moeda-total"
                                             v-on:click="exitLocal(pointsExit)" :title="descs.points.description">
                                            <p>{{ TotalPoints }}</p>
                                            <div v-html="this.header_buttons.points_button"></div>
                                        </div>
                                    </div>
                                    <div v-if="this.switch.event_menu && this.switch.event_menu['score_moedas']">
                                        <div style="margin-right: 10px; padding-right: 5px;cursor: default;" id="coin" v-if="this.switch.Habilitar_Moedas && this.switch.coins_on_header"
                                             class="alignVerticalEnd ponto-total" v-on:click="openPackage"
                                             >
                                            <p>{{ TotalCoins }}</p>
                                            <div v-html="this.header_buttons.coins_button"></div>
                                            <label for="coin" v-show="descs.coin.active"
                                                   class="desc">{{ descs.coin.description }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="tools && !isMobile" class="tools alignVerticalEnd noWarp">
                                <div  v-html="this.header_buttons.camera_button" id="_selfie" v-if="(this.switch.event_menu && this.switch.event_menu['camera']) && (this.switch.Habilitar_Selfies || this.switch.selfies_blog)"
                                     v-on:click="openSelfieModal()"
                                     class="icon alignVertical" :title="descs.selfie.description">

                                </div>

                                <div v-if="this.switch.event_menu && this.switch.event_menu['notificacoes']">
                                    <div id="_noti" v-if="this.switch.Habilitar_Notificações_Header" style="padding-bottom:3px;"
                                         v-on:click="camera = false;notifications_count = 0;getNotifications();mobileClose();"
                                         :title="descs.noti.description"
                                         class="icon alignVertical">
                                        <div :class="(this.notifications_count != 0 ? ' notification' : '')" v-html="this.header_buttons.notification_button">
                                            
                                        </div>
                                    </div>
                                </div>

                                <div id="_menu" v-if="this.smartphone_options"
                                     v-on:click="notification = false;camera = false;$refs['mobile'].mobileHandler();"
                                     :title="descs.menu.description"
                                     class="icon alignVertical" v-html="this.header_buttons.menu_button">
                                    
                                </div>
                                <div v-if="LibraryName && LibraryName.length>0 && this.switch.event_menu && this.switch.event_menu['biblioteca']" v-on:click="notification = false;camera = false;conteudoHandler();mobileClose()" class="icon alignVertical"
                                     :title="LibraryName" v-html="this.header_buttons.library_button"
                                >

                                </div>
                                <div v-if="this.switch.radio"
                                     :title="descs.radio.description">
                                    <MusicPlayer class="icon alignVertical" :radios="radio"/>
                                </div>

                                <div id="_shutoff" v-if="this.switch.without_landing_page != 'without_landing_page' || this.logged" v-on:click="logout" class="icon alignVertical"
                                     :title="descs.shutoff.description" v-html="this.header_buttons.logoff_button">
                                </div>
                                <div v-if="user_type == 'moderator'" v-on:click="moderatorHandler"
                                     class="icon alignVertical">
<!--                                    svg engrenagem-->
                                    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="20px" height="20px">
                                        <path stroke-width="2" fill="var(--buttons_color)" d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"/>
                                    </svg>
                                </div>

                                <div class="iconLanguage alignVertical" v-if="this.switch.multilanguages">
                                    <v-select ref="localeSelect" v-model="$i18n.locale" @input="setLocale"
                                              :options="options" :searchable="false" :reduce="option => option.code" :clearable="false">
                                        <template #open-indicator="{ }"></template>
                                        <template #selected-option="{  }">
                                            <div style="display:flex;align-items:center;" v-html="header_buttons.language_button"></div>
                                        </template>
                                        <template slot="option" slot-scope="option" v-if="option.active">
                                            <img width="20px" :src="option.icon" />
                                        </template>
                                    </v-select>
                                </div>

                                <div id="_help" v-on:click="link('Support')" class="iconAjuda alignVertical"
                                     :title="descs.help.description" :style="isMobile ? { marginRight: '8px'} : ''" v-html="this.header_buttons.help_button">
                                </div>
                            </div>
                            <div v-if="isMobile" style="display: none;">
                                <div v-if="tools && isMobile " class="tools alignVerticalEnd noWarp"  style="padding-right: 12px;">
                                    <div class="iconLanguage" v-if="this.switch.multilanguages && !this.showTools" style="margin-right: 10px">
                                        <v-select ref="localeSelect" v-model="$i18n.locale" @input="setLocale"
                                                :options="options" :searchable="false" :reduce="option => option.code" :clearable="false">
                                            <template #open-indicator="{ }"></template>
                                            <template #selected-option="{  }">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_1798_12453)">
                                                        <path d="M0.5 8C0.5 12.1422 3.85775 15.5 8 15.5C12.1422 15.5 15.5 12.1422 15.5 8C15.5 3.85775 12.1422 0.5 8 0.5C3.85775 0.5 0.5 3.85775 0.5 8Z" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M8.75 0.537476C8.75 0.537476 11 3.49998 11 7.99997C11 12.5 8.75 15.4625 8.75 15.4625" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M7.25 15.4625C7.25 15.4625 5 12.5 5 7.99997C5 3.49998 7.25 0.537476 7.25 0.537476" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M0.972656 10.625H15.0277" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M0.972656 5.375H15.0277" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_1798_12453">
                                                            <rect width="16" height="16" fill="white" transform="translate(0 0.134277)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </template>
                                            <template slot="option" slot-scope="option" v-if="option.active">
                                                <img width="20px" :src="option.icon" />
                                            </template>
                                        </v-select>
                                    </div>
                                <div style="padding-right: 12px;">
                                    <div v-if="!showTools" v-on:click="showMobileTools">
                                        <svg width="22" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 0H24V2.6875H0V0ZM0 9.3125V6.6875H24V9.3125H0ZM0 16V13.3125H24V16H0Z" fill="var(--buttons_color)"/>
                                        </svg>
                                    </div>
                                    <div v-else-if="showTools" class="toolsMobile" style="z-index: 999999; position: relative;">
                                        <div v-on:click="showMobileTools" style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                            <svg width="26" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.3125 2.5625L11.875 10L19.3125 17.4375L17.4375 19.3125L10 11.875L2.5625 19.3125L0.6875 17.4375L8.125 10L0.6875 2.5625L2.5625 0.6875L10 8.125L17.4375 0.6875L19.3125 2.5625Z" fill="var(--buttons_color)"/>
                                            </svg>
                                        </div>

                                        <div v-if="(this.switch.event_menu && this.switch.event_menu['camera']) && (this.switch.Habilitar_Selfies || this.switch.selfies_blog)"
                                            style="background: var(--buttons_color); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;"
                                            v-on:click="showTools = false;openSelfieModal();"
                                            :title="descs.selfie.description">
                                            <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.54688 17.4531C9.79688 18.6641 11.2812 19.2695 13 19.2695C14.7188 19.2695 16.1836 18.6641 17.3945 17.4531C18.6445 16.2031 19.2695 14.7188 19.2695 13C19.2695 11.2813 18.6445 9.81641 17.3945 8.60547C16.1836 7.35547 14.7188 6.73047 13 6.73047C11.2812 6.73047 9.79688 7.35547 8.54688 8.60547C7.33594 9.81641 6.73047 11.2813 6.73047 13C6.73047 14.7188 7.33594 16.2031 8.54688 17.4531ZM9.25 0.519531H16.75L19.0352 2.98047H23.0195C23.6836 2.98047 24.25 3.23437 24.7188 3.74219C25.2266 4.25 25.4805 4.83594 25.4805 5.5V20.5C25.4805 21.1641 25.2266 21.75 24.7188 22.2578C24.25 22.7656 23.6836 23.0195 23.0195 23.0195H2.98047C2.31641 23.0195 1.73047 22.7656 1.22266 22.2578C0.753906 21.75 0.519531 21.1641 0.519531 20.5V5.5C0.519531 4.83594 0.753906 4.25 1.22266 3.74219C1.73047 3.23437 2.31641 2.98047 2.98047 2.98047H6.96484L9.25 0.519531ZM10.1875 15.8125C9.40625 15.0312 9.01562 14.0938 9.01562 13C9.01562 11.9062 9.40625 10.9687 10.1875 10.1875C10.9688 9.40625 11.9062 9.01562 13 9.01562C14.0938 9.01562 15.0312 9.40625 15.8125 10.1875C16.5938 10.9687 16.9844 11.9062 16.9844 13C16.9844 14.0938 16.5938 15.0312 15.8125 15.8125C15.0312 16.5938 14.0938 16.9844 13 16.9844C11.9062 16.9844 10.9688 16.5938 10.1875 15.8125Z" fill="var(--fonts_color)"/>
                                            </svg>
                                        </div>

                                        <div v-if="this.switch.event_menu && this.switch.event_menu['notificacoes'] && this.switch.Habilitar_Notificações_Header" style="background: var(--buttons_color); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;" v-on:click="showTools = false;camera = false;notifications_count = 0;getNotifications();mobileClose();">
                                            <div :class="(this.notifications_count != 0 ? ' mobileNotifications' : '')">
                                                <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.7578 23.7773C14.2891 24.2461 13.7031 24.4805 13 24.4805C12.2969 24.4805 11.6914 24.2461 11.1836 23.7773C10.7148 23.2695 10.4805 22.6836 10.4805 22.0195H15.4609C15.4609 22.7227 15.2266 23.3086 14.7578 23.7773ZM20.5 10.7695V16.9805L23.0195 19.5V20.7305H2.98047V19.5L5.5 16.9805V10.7695C5.5 8.81641 5.98828 7.11719 6.96484 5.67188C7.98047 4.22656 9.36719 3.28906 11.125 2.85938V1.98047C11.125 1.47266 11.3008 1.04297 11.6523 0.691406C12.0039 0.300781 12.4531 0.105469 13 0.105469C13.5469 0.105469 13.9961 0.300781 14.3477 0.691406C14.6992 1.04297 14.875 1.47266 14.875 1.98047V2.85938C16.6328 3.28906 18 4.22656 18.9766 5.67188C19.9922 7.11719 20.5 8.81641 20.5 10.7695ZM22.9609 10.125C22.8828 8.71875 22.4141 7.23438 21.5547 5.67188C20.6953 4.10937 19.6992 2.91797 18.5664 2.09766L20.3242 0.339844C23.5664 2.83984 25.2852 6.10156 25.4805 10.125H22.9609ZM7.49219 2.09766C6.35938 2.91797 5.34375 4.10937 4.44531 5.67188C3.58594 7.23438 3.11719 8.71875 3.03906 10.125H0.519531C0.714844 6.10156 2.43359 2.83984 5.67578 0.339844L7.49219 2.09766Z" fill="var(--fonts_color)"/>
                                                </svg>
                                            </div>
                                        </div>

                                        <div v-if="LibraryName && LibraryName.length>0 && this.switch.event_menu && this.switch.event_menu['biblioteca']" style="background: var(--buttons_color); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;"
                                            v-on:click="showTools = false;notification = false;camera = false;conteudoHandler();mobileClose()"
                                            :title="LibraryName">
                                            <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.8555 12.9297C21.8711 12.9297 22.9258 13.0273 24.0195 13.2227V15.0977C23.2383 14.9023 22.1836 14.8047 20.8555 14.8047C18.5117 14.8047 16.6367 15.2148 15.2305 16.0352V13.9258C16.7148 13.2617 18.5898 12.9297 20.8555 12.9297ZM15.2305 10.5859C16.8711 9.92188 18.7461 9.58984 20.8555 9.58984C21.8711 9.58984 22.9258 9.6875 24.0195 9.88281V11.7578C23.2383 11.5625 22.1836 11.4648 20.8555 11.4648C18.5117 11.4648 16.6367 11.875 15.2305 12.6953V10.5859ZM20.8555 8.125C18.5117 8.125 16.6367 8.53516 15.2305 9.35547V7.30469C16.793 6.60156 18.668 6.25 20.8555 6.25C21.8711 6.25 22.9258 6.34766 24.0195 6.54297V8.47656C23.082 8.24219 22.0273 8.125 20.8555 8.125ZM25.25 18.1445V3.73047C23.9609 3.33984 22.4961 3.14453 20.8555 3.14453C18.3164 3.14453 16.0312 3.76953 14 5.01953V19.375C16.0312 18.125 18.3164 17.5 20.8555 17.5C22.3789 17.5 23.8438 17.7148 25.25 18.1445ZM20.8555 0.625C23.8242 0.625 26.1289 1.25 27.7695 2.5V20.7227C27.7695 20.8789 27.6914 21.0352 27.5352 21.1914C27.418 21.3086 27.2812 21.3672 27.125 21.3672C27.0078 21.3672 26.9102 21.3477 26.832 21.3086C25.2305 20.4492 23.2383 20.0195 20.8555 20.0195C18.3164 20.0195 16.0312 20.6445 14 21.8945C12.3203 20.6445 10.0352 20.0195 7.14453 20.0195C5.03516 20.0195 3.04297 20.4688 1.16797 21.3672C1.12891 21.3672 1.07031 21.3867 0.992188 21.4258C0.953125 21.4258 0.914062 21.4258 0.875 21.4258C0.71875 21.4258 0.5625 21.3672 0.40625 21.25C0.289062 21.1328 0.230469 20.9961 0.230469 20.8398V2.5C1.91016 1.25 4.21484 0.625 7.14453 0.625C10.0352 0.625 12.3203 1.25 14 2.5C15.6797 1.25 17.9648 0.625 20.8555 0.625Z" fill="var(--fonts_color)"/>
                                            </svg>

                                        </div>

                                        <div v-if="this.switch.radio" style="background: var(--buttons_color); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                            <div style="margin-top: -2px !important">
                                                <MusicPlayer :radios="radio"/>
                                            </div>
                                        </div>

                                        <div style="background: var(--buttons_color); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;" v-on:click="link('Support'); showTools = !showTools">
                                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.8086 12.0625C17.5898 11.2813 17.9805 10.3438 17.9805 9.25C17.9805 7.88281 17.4922 6.71094 16.5156 5.73438C15.5391 4.75781 14.3672 4.26953 13 4.26953C11.6328 4.26953 10.4609 4.75781 9.48438 5.73438C8.50781 6.71094 8.01953 7.88281 8.01953 9.25H10.4805C10.4805 8.58594 10.7344 8 11.2422 7.49219C11.75 6.98437 12.3359 6.73047 13 6.73047C13.6641 6.73047 14.25 6.98437 14.7578 7.49219C15.2656 8 15.5195 8.58594 15.5195 9.25C15.5195 9.91406 15.2656 10.5 14.7578 11.0078L13.2344 12.5898C12.2578 13.6445 11.7695 14.8164 11.7695 16.1055V16.75H14.2305C14.2305 15.4609 14.7188 14.2891 15.6953 13.2344L16.8086 12.0625ZM14.2305 21.7305V19.2695H11.7695V21.7305H14.2305ZM4.15234 4.21094C6.61328 1.75 9.5625 0.519531 13 0.519531C16.4375 0.519531 19.3672 1.75 21.7891 4.21094C24.25 6.63281 25.4805 9.5625 25.4805 13C25.4805 16.4375 24.25 19.3867 21.7891 21.8477C19.3672 24.2695 16.4375 25.4805 13 25.4805C9.5625 25.4805 6.61328 24.2695 4.15234 21.8477C1.73047 19.3867 0.519531 16.4375 0.519531 13C0.519531 9.5625 1.73047 6.63281 4.15234 4.21094Z" fill="var(--fonts_color)"/>
                                            </svg>
                                        </div>
                                        <div style="background: var(--buttons_color); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;" v-if="this.switch.without_landing_page != 'without_landing_page' || this.logged" v-on:click="logout">
                                            <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.98047 3.26953V20.7305H13V23.25H2.98047C2.31641 23.25 1.73047 22.9961 1.22266 22.4883C0.753906 21.9805 0.519531 21.3945 0.519531 20.7305V3.26953C0.519531 2.60547 0.753906 2.01953 1.22266 1.51172C1.73047 1.00391 2.31641 0.75 2.98047 0.75H13V3.26953H2.98047ZM19.2695 5.73047L25.4805 12L19.2695 18.2695L17.5117 16.4531L20.7344 13.2305H8.01953V10.7695H20.7344L17.5117 7.48828L19.2695 5.73047Z" fill="var(--fonts_color)"/></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div v-if="showTools" class="toolsHamburguer">
                                <div class="toolsBackdrop" v-on:click="showMobileTools"></div>
                            </div>
                            <div v-if="isMobile">
                                <div v-if="tools && isMobile " class="tools alignVerticalEnd noWarp"  style="padding-right: 12px;">
                                    <div class="iconLanguage" v-if="this.switch.multilanguages && !this.showTools" style="margin-right: 10px">
                                        <v-select ref="localeSelect" v-model="$i18n.locale" @input="setLocale"
                                                :options="options" :searchable="false" :reduce="option => option.code" :clearable="false">
                                            <template #open-indicator="{ }"></template>
                                            <template #selected-option="{  }">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_1798_12453)">
                                                        <path d="M0.5 8C0.5 12.1422 3.85775 15.5 8 15.5C12.1422 15.5 15.5 12.1422 15.5 8C15.5 3.85775 12.1422 0.5 8 0.5C3.85775 0.5 0.5 3.85775 0.5 8Z" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M8.75 0.537476C8.75 0.537476 11 3.49998 11 7.99997C11 12.5 8.75 15.4625 8.75 15.4625" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M7.25 15.4625C7.25 15.4625 5 12.5 5 7.99997C5 3.49998 7.25 0.537476 7.25 0.537476" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M0.972656 10.625H15.0277" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M0.972656 5.375H15.0277" stroke="var(--buttons_color)" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_1798_12453">
                                                            <rect width="16" height="16" fill="white" transform="translate(0 0.134277)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </template>
                                            <template slot="option" slot-scope="option" v-if="option.active">
                                                <img width="20px" :src="option.icon" />
                                            </template>
                                        </v-select>
                                    </div>
                                <div style="padding-right: 12px;">
                                    <div v-if="!showTools" v-on:click="showMobileTools">
                                        <svg width="22" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 0H24V2.6875H0V0ZM0 9.3125V6.6875H24V9.3125H0ZM0 16V13.3125H24V16H0Z" fill="var(--buttons_color)"/>
                                        </svg>
                                    </div>
                                    <div v-else-if="showTools" class="toolsMobile" style="z-index: 999999; position: relative;">
                                        <div v-on:click="showMobileTools" style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                            <svg width="26" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19.3125 2.5625L11.875 10L19.3125 17.4375L17.4375 19.3125L10 11.875L2.5625 19.3125L0.6875 17.4375L8.125 10L0.6875 2.5625L2.5625 0.6875L10 8.125L17.4375 0.6875L19.3125 2.5625Z" fill="var(--buttons_color)"/>
                                            </svg>
                                        </div>

                                        <div v-html="this.header_buttons.camera_button" v-if="(this.switch.event_menu && this.switch.event_menu['camera']) && (this.switch.Habilitar_Selfies || this.switch.selfies_blog)"
                                            style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;"
                                            v-on:click="showTools = false;openSelfieModal();"
                                            :title="descs.selfie.description">
                                        </div>

                                        <div v-html="this.header_buttons.notification_button" :class="(this.notifications_count != 0 ? ' mobileNotifications' : '')" v-if="this.switch.event_menu && this.switch.event_menu['notificacoes'] && this.switch.Habilitar_Notificações_Header" style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;" v-on:click="showTools = false;camera = false;notifications_count = 0;getNotifications();mobileClose();">
                                        </div>

                                        <div v-html="this.header_buttons.library_button" v-if="LibraryName && LibraryName.length>0 && this.switch.event_menu && this.switch.event_menu['biblioteca']" style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;"
                                            v-on:click="showTools = false;notification = false;camera = false;conteudoHandler();mobileClose()"
                                            :title="LibraryName">
                                        </div>

                                        <div v-if="this.switch.radio" style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                            <div style="margin-top: -2px !important">
                                                <MusicPlayer :radios="radio"/>
                                            </div>
                                        </div>

                                        <div v-html="this.header_buttons.help_button" style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;" v-on:click="link('Support'); showTools = !showTools">
                                        </div>

                                        <div v-html="this.header_buttons.logoff_button" style="background: var(--headers_color_logged); padding: 8px; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;" v-if="this.switch.without_landing_page != 'without_landing_page' || this.logged" v-on:click="logout">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div v-if="showTools" class="toolsHamburguer">
                                <div class="toolsBackdrop" v-on:click="showMobileTools"></div>
                            </div>
                        </div>
                        <div v-if="!this.isMobile && this.switch.btn_promotional.active" style="width: 360px;">
                            <BtnPromotional v-if="this.switch.btn_promotional.active && !this.isGuest"/>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div id="audioPlayers" style="display:none;">
            <div
                v-if="this.isMobile && this.current_session.audio && this.showAudioButton && (logged || isGuest) && this.control_audio"
                style="cursor: pointer;position:absolute;float: left; margin: 55px 10px">
                <img v-on:click="audioPause" src="../public/assets/img/header/audio_on.png">
            </div>

            <div
                v-if="this.isMobile && this.current_session.audio && this.showAudioButton && (logged || isGuest) && !this.control_audio"
                style="cursor: pointer;position:absolute;float: left; margin: 55px 10px">
                <img v-on:click="audioPlay" src="../public/assets/img/header/audio_off.png">
            </div>

            <div
                v-if="!this.isMobile && this.current_session.audio && this.showAudioButton && (logged || isGuest) && this.control_audio"
                style="cursor: pointer;position:absolute;float: left; margin: 15px 10px">
                <img v-on:click="audioPause" src="../public/assets/img/header/audio_on.png">
            </div>

            <div
                v-if="!this.isMobile && this.current_session.audio && this.showAudioButton && (logged || isGuest) && !this.control_audio"
                style="cursor: pointer;position:absolute;float: left; margin: 15px 10px">
                <img v-on:click="audioPlay" src="../public/assets/img/header/audio_off.png">
            </div>
        </div>

        <audio controls loop="true" ref="audioPlay" id="audioPlay" hidden>
            <source v-bind:src=this.current_session.audio type="audio/mpeg">
        </audio>
        <video id="myVideoPlayer" style="display: none;" class="video-js vjs-default-skin" controls>
            <source
                ref="videoPlay"
                v-bind:src=this.current_session.audio
                type="application/x-mpegURL">
        </video>

        <router-view v-if="started ||access_before_start.includes($route.name)" ref="main" :key="$route.path"
                     style=""></router-view>

        <iframe v-show="iframe_temp" id="iframe_temp" ref="iframe_temp" :src="iframe_temp_url" frameborder="0"
                allow="autoplay;" allowfullscreen="allowfullscreen" scrolling="no"></iframe>


        <a id="ondeComprar" href="#" data-tobuy-modal="open" data-tobuy-hash="seara" style="display: none;">
            Comprar
        </a>

        <TicketGate ref="ticket-gate"></TicketGate>
        <!--    <AmbientTransition v-if="ambient_transition && (((this.$route.name == 'Museum') || (this.$route.name == 'LockerRoom')) || (ticket_gate_ok))" ref="ambient_transition"></AmbientTransition>-->
        <!--    <AmbientTransition v-if="ambient_transition"     ref="ambient_transition"></AmbientTransition>-->
        <AmbientTransition v-if="show_quiz" ref="ambient_transition"></AmbientTransition>


        <div v-if="isLms">
            <LmsWebSocket></LmsWebSocket>
        </div>
        <div v-else>
            <ChatAdmin v-if="this.switch.websockets && (logged || isGuest) && nickname && started" style="height: 0;overflow: hidden" ref="chat_admin" key="ChatAdmin" interactive="admin"></ChatAdmin>

            <Chat :style="openChatButton ? { display: 'none !important'} : ''" v-if="started && this.switch.websockets && (logged || isGuest) && nickname && chat"
                ref="chat" key="chat" :max="chat_max" :audio="chat_audio" :room="chat_room" :participants="chat_participants"
                :interactive="chat_interactive" :locale="this.$i18n.locale"></Chat>
        </div>

        <Mobile v-if="(logged || isGuest) && this.smartphone_options" id="mobile" ref="mobile"></Mobile>
        <EasterEgg v-if="easter" id="EasterEgg" ref="EasterEgg"></EasterEgg>

        <Camera v-if="camera" id="Camera" ref="Camera" :open_gallery="open_gallery"></Camera>
        <Notification v-if="notification" :list="notification_list"></Notification>
        <Login v-if="(!logged || isGuest) && modal_login_"></Login>
        <Signup v-if="(isGuest || !logged) && modal_cadastro_"></Signup>
        <ModalBadgesVue v-if="logged && modal_badge_" ref=""
                        :badge_file="badge.file_url"
                        :badge_name="badge.name"
                        :badge_text="badge.text"
                        :badge_external_url="badge.external_url"></ModalBadgesVue>
        <EmailConfirmation v-if="logged && modal_validacao_"></EmailConfirmation>
        <RememberPassword v-if="!logged && modal_RememberPassword"></RememberPassword>
        <ResetPassword v-if="!logged && modal_ResetPassword"></ResetPassword>


        <PoliticaDePrivacidade v-if="modal_PoliticaDePrivacidade"></PoliticaDePrivacidade>
        <Wizard v-if="modal_Wizard"></Wizard>
        <!--Termos v-if="modal_Termos" :regulamento="regulamento"></Termos>-->

        <Group v-if="group_active"></Group>
        <Conteudo v-if="conteudo"></Conteudo>
        <Oracle v-if="false" id="oracle" ref="oracle"></Oracle>
        <VT v-if="store_vt" id="vt" ref="vt"></VT>
        <Vtex v-if="store_vtex" id="vtex" ref="vtex"></Vtex>
        <Video v-if="unity_video" :video_url="unity_video"></Video>
        <Modal v-if="modal_" ref="modal" :modal_type="modal_type" :modal_title="modal_title" :modal_text="modal_text"
               :modal_response="modal_response" :modal_yes="modal_yes" :modal_no="modal_no" :modal_btn="modal_btn"
               :modal_iframe_url="modal_iframe_url"></Modal>
        <ModalIframe v-if="modal_iframe" :modal_iframe_type="modal_iframe_type" ref="modal_iframe"></ModalIframe>
        <SessionAccess v-if="session_access" :mode="session_access_type" ref="session_access"></SessionAccess>
        <Share ref="shareComponent"/>
        <Package v-if="modal_package"></Package>
        <CoinsBuy v-if="modal_coins_buy" ref="coinsBuy"></CoinsBuy>
        <PackageBuy v-if="modal_package_buy"></PackageBuy>
        <GuestBuy v-if="modal_guest_buy"></GuestBuy>
        <PackagePayments v-if="modal_package_payments"></PackagePayments>
        <Mural ref="muralPosts"/>
        <TranslucentModal v-for="(tModal,iTModal) in translucent_modals" v-show="iTModal===translucent_modals.length-1" :key="tModal.id" :modalInfo="tModal"/>
        <ModalRewards v-if="(logged || isGuest) && modal_rewards"
                      :ctaButton="reward_cta_button"
                      :ctaLabel="reward_cta_label"
                      :message="reward_message"></ModalRewards>
        <ModalPopupPoints v-if="(logged || isGuest) && popUpPoints"
                          :ctaButton="popupInfo.url_cta"
                          :ctaLabel="popupInfo.label_cta"
                          :message="popupInfo.message"></ModalPopupPoints>
        <SelfieController v-if="logged || isGuest" ref="selfieControl"/>
        <TicketGateModal v-if="modal_ticket_gate" ref="ticketGate"></TicketGateModal>
        <PackageSingle v-if="modal_package_single"></PackageSingle>
        <PrivateMessages v-if="modal_private_messages" ref="pm_messages"></PrivateMessages>
        <Quest v-if="modal_quest" ref="quest"></Quest>
        <div v-if="tutorial" id="tutorial-handler" ref="tutorial-handler" class="modals bgBlack">
            <div style="width: 100vw;height: 100vh;position: fixed;top: 0;left: 0;" data-response="0"
                 v-on:click="tutorialHandler"></div>
            <div ref="tutorial-handler-content" class="modalGerais">
                <div class="modals__content flex" style="background:transparent">
                    <div class="modals__content--header alignVertical">
                        <a href="#" class="close" data-response="0" v-on:click="tutorialHandler">
                            <img src="assets/icons/modals/x.svg" alt=""/>
                        </a>
                    </div>
                    <div class="modals__content--body alignVertical"
                         style="padding-top:0px;margin-top:5px;margin-bottom:0px;padding-bottom:10px;max-width:100%">
                        <div class="modalGerais__tutorial">
                            <iframe src="https://player.vimeo.com/video/571359162" style="height:400px"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- complaint -->
        <div v-if="complaint" id="complaint-box" ref="complaint-box" class="modals bgBlack">
            <div style="width: 100vw;height: 100vh;position: fixed;top: 0;left: 0;" data-response="0"
                 v-on:click="complaintOpenHandler"></div>
            <div ref="buy-handler-content" class="modalGerais">
                <div class="modals__content flex flex--column">
                    <div class="modals__content--header alignVertical">
                        <p>{{ $t('denunciar') }}</p>
                        <a class="btn-0" v-on:click="complaintOpenHandler" ref="btn-close">
                            <img src="assets/icons/modals/x.svg" alt=""/>
                        </a>
                    </div>
                    <div class="modals__content--body alignVertical"
                         :style="'background-image: url(\'' +$url +'assets/icons/modals/biblioteca.png\');'">
                        <div class="modalGerais__denunciar">
                            <input id="id_user" name="id_user" ref="id_user" type="hidden"/>
                            <input id="reason" name="reason" ref="reason" type="hidden"/>
                            <label class="container alignVertical">{{ $t('app.linguagemOuContedoImprprio') }}
                                <input v-on:change="complaintValueHandler" type="radio" name="complaint-reason"
                                       value="Linguagem ou contúdo impróprio"/>
                                <span class="checkmark"></span>
                            </label>

                            <label class="container alignVertical">{{ $t('app.mensagensDeDio') }}
                                <input v-on:change="complaintValueHandler" type="radio" name="complaint-reason"
                                       value="Mensagens de ódio / Ofensiva"/>
                                <span class="checkmark"></span>
                            </label>

                            <label class="container alignVertical">{{ $t('app.spam') }}
                                <input v-on:change="complaintValueHandler" type="radio" name="complaint-reason"
                                       value="Spam"/>
                                <span class="checkmark"></span>
                            </label>

                            <label class="container alignVertical">{{ $t('app.contaFalsa') }}
                                <input v-on:change="complaintValueHandler" type="radio" name="complaint-reason"
                                       value="Conta Falsa"/>
                                <span class="checkmark"></span>
                            </label>

                            <label class="container alignVertical">{{ $t('app.outras') }}
                                <input v-on:change="complaintValueHandler" type="radio" name="complaint-reason"
                                       value="Outros"/>
                                <span class="checkmark"></span>
                            </label>

                            <div class="col-6 flex">
                                <input class="text" name="complaint-message" id="complaint-message"
                                       ref="complaint-message"
                                       :placeholder="$t('app.outroMotivo')" type="text"/>
                            </div>

                            <div class="col-6 flex flex-wrap">
                                <button v-on:click="complaintHandler">{{ $t('app.enviar') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- -->

        <!-- webcam photo -->
        <div id="webcam-photo" ref="webcam-photo" style="display:none">
            <div id="webcam-photo-content" ref="webcam-photo-content">
                <div id="webcam-photo-header" ref="webcam-photo-header">
                    {{ $t('app.tireUmaSelfie') }}
                    <a class="fr" href="#" v-on:click="webCamExit">
                        <img :src="$url + 'assets/img/icon_close_box.png'" alt="Fechar" width="16" height="16"/>
                    </a>
                </div>
                <video id="webcam-photo-video"></video>
                <canvas id="webcam-photo-canvas"></canvas>
                <div id="webcam-btns" ref="webcam-btns">
                    <a href="#" id="webcam-photo-capture" v-on:click="webCamCapture"
                       style="display:block;padding: 10px 0">
                        <img :src="$url + 'assets/img/webcam/take_photo.png'" alt="Tirar foto"/>
                    </a>
                    <!--<button class="button__buttonForm button__blue col-4" id='webcam-photo-capture' v-on:click="webCamCapture">Capturar</button>-->
                    <!--<button class="button__buttonForm button__blue col-4" id='webcam-photo-discard' v-on:click="webCamDiscard">Descartar</button>-->
                    <a href="#" id="webcam-photo-discard" v-on:click="webCamDiscard" style="padding: 10px 0">
                        <img :src="$url + 'assets/img/webcam/discard.png'" alt="Descartar foto" width="53"/>
                    </a>
                    <!--<button class="button__buttonForm button__blue col-4" id='webcam-photo-save' v-on:click="webCamSave">Salvar</button>-->
                    <a href="#" id="webcam-photo-save" v-on:click="webCamSave" style="padding: 10px 0">
                        <img :src="$url + 'assets/img/webcam/save.png'" alt="Salvar foto"/>
                    </a>
                    <!--<button class="button__buttonForm button__blue col-4" id='webcam-photo-exit' ">Fechar</button>-->
                </div>
            </div>
        </div>

        <!-- <FileUploader :extensionsArray="allowedExtensions" :allowUpload="true" :useStrictFilter="true" modal-id="thumbFileModalId" v-if="file_uploader" emit-event="thumb::changed"></FileUploader> -->
        <!-- -->
        <Popup :notifications="this.popup_notifications"/>
        <!-- loader -->
        <!-- <div id="loader" ref="loader">
                <div id="loader-ani"></div>
            </div> -->
        <Loading v-if="loading"></Loading>
        <!-- -->
        <div ref="copyright_footer" v-if="!this.logged && !this.isGuest && design.copyright_footer"
             class="copyright_footer">
            <p>{{ design.copyright_footer }}</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters} from "vuex";
import Mobile from "@/components/Mobile";
import EasterEgg from "@/components/EasterEgg";
import Camera from "@/components/Camera";
import Notification from "@/components/Notification";
import Modal from "@/components/Modal";
import ModalIframe from "@/components/ModalIframe";
import SessionAccess from "@/components/SessionAccess";
import Chat from "@/components/Chat";
import ChatAdmin from "@/components/Chat";
import Group from "@/components/Group";
import Conteudo from "@/components/Conteudo";
import Video from "@/components/Video";
import AmbientTransition from "@/components/AmbientTransition";
import Login from "@/components/login/Login";
import Signup from "@/components/login/Signup";
import LoginAzure from "@/components/login/LoginAzure";
import LoginFacebook from "@/components/login/LoginFacebook";
import LoginGoogle from "@/components/login/LoginGoogle";
import ModalBadgesVue from "./components/ModalBadges.vue";
import EmailConfirmation from "@/components/EmailConfirmation";
import RememberPassword from "@/components/RememberPassword";
import ResetPassword from "@/components/ResetPassword";
import PoliticaDePrivacidade from "@/components/PoliticaDePrivacidade";
import Wizard from "@/components/Wizard";
//import Termos from "@/components/Termos";
import MusicPlayer from "@/components/MusicPlayer";
import TicketGate from "@/components/TicketGate";
import ModalRewards from "@/components/ModalRewards";
import ModalPopupPoints from "@/components/ModalPopupPoints";
import Oracle from "@/components/oracle/Oracle";
import VT from "@/components/vt/VT";
import Vtex from "@/components/vtex/Vtex";
import logoDefault from "./assets/img/loading.gif";
import logoLoading from "./assets/img/loading.gif";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import 'vue-select/dist/vue-select.css';
import Popup from "@/components/Notifications/Popup";
import BtnPromotional from "@/components/Notifications/BtnPromotional";
import Share from "@/components/Modals/Share";
import Package from "@/components/Package";
import PackageBuy from "@/components/PackageBuy";
import PackagePayments from "@/components/PackagePayments";
import Mural from "@/components/Modals/Mural";
import SelfieController from "@/components/Modals/Posts/SelfieController";
import CoinsBuy from "@/components/Package";
import GuestBuy from "@/components/Package";
import TicketGateModal from "@/components/Modals/TicketGate";
import PackageSingle from "@/components/Modals/PackageSingle";
import PrivateMessages from "@/components/Modals/PrivateMessages";
import Quest from "@/components/Quest";
import Loading from "@/components/Loading";
import CryptoJS from 'crypto-js';
import LmsHeader from "@/components/lms/components/LmsHeader";
import LmsWebSocket from "@/components/lms/LmsWebSocket.vue";
import TranslucentModal from "@/components/Modals/TranslucentModal";
// import FileUploader from '@/components/lms/components/FileUploader';

const isWebview = require("is-ua-webview");

// import $ from "jquery";
import { insertHtmlWithScript, extractSceneNameFromURL, removeDivById,focusUnity } from "@/helper";

export default {
    name: "App",
    props: ['eventName', 'sessionName'],
    computed: {
        ...mapGetters([
            "id", "switch", "token", "email", "logged", "dat", "id_form_actual", "isGuest", "name", "nickname", "age", "email_verified", "age_verified",
            "url_actual", "started", "TotalPoints", "TotalCoins", "TotalBadges", "EventimTickets", "NotificationsList", "UserTickets", "use_avatar", "avatar_metaverse", "user_picture",
            "sessions", "current_session", "webview", "user_type", "is_guest", "groups", "group_id", "stores", "store_vt", "store_vtex","design",
            'quest', 'header_buttons',
            "checkIOS","checkMobile",'LibraryName', "reward_slug",'smartphone_options', 'UserBadges', 'UserTickets', 'event_id', 'avatar_map', 'avatar_first_session', 'last_local',
            "unity_hash_log"
        ]),
        ...mapGetters("LMS", ["isLms", "getLms"]),
        ...mapGetters({
            template_html_loaded: 'TemplateHTML/getHTMLTemplateLoaded',
            template_html: 'TemplateHTML/getHTMLTemplate',
        }),
        cssVars() {
            return {
                "--buttons_color-r": this.hexToRgb(this.design?.color?.buttons_color || this.getCookie("design_color_buttons_color") || "#fff")?.r || 255,
                "--buttons_color-g": this.hexToRgb(this.design?.color?.buttons_color || this.getCookie("design_color_buttons_color") || "#fff")?.g || 255,
                "--buttons_color-b": this.hexToRgb(this.design?.color?.buttons_color || this.getCookie("design_color_buttons_color") || "#fff")?.b || 255,
                "--buttons_color_2nd-r": this.hexToRgb(this.design?.color?.buttons_color_2nd || this.getCookie("design_color_buttons_color_2nd") || "#fff")?.r || 255,
                "--buttons_color_2nd-g": this.hexToRgb(this.design?.color?.buttons_color_2nd || this.getCookie("design_color_buttons_color_2nd") || "#fff")?.g || 255,
                "--buttons_color_2nd-b": this.hexToRgb(this.design?.color?.buttons_color_2nd || this.getCookie("design_color_buttons_color_2nd") || "#fff")?.b || 255,
                "--buttons_color": this.design?.color?.buttons_color || this.getCookie("design_color_buttons_color") || "#fff",
                "--buttons_color_2nd": this.design?.color?.buttons_color_2nd || this.getCookie("design_color_buttons_color_2nd") || "#fff",
                "--fonts_color": this.design?.color?.fonts_color || this.getCookie("design_color_fonts_color") || "#000000",
                "--fonts_color_2nd": this.design?.color?.fonts_color_2nd || this.getCookie("design_color_fonts_color_2nd") || "#000000",
                "--headers_color": this.design?.color?.headers_color || this.getCookie("design_color_headers_color") || "#FFFF",
                "--headers_color_logged": this.design?.color?.headers_color_logged || this.getCookie("design_color_headers_color_logged") || "#FFFF",
                "--chat_bg_color": this.design?.color?.chat_bg_color || this.getCookie("design_color_chat_bg_color") || "#FFFF",
                "--chat_text_color": this.design?.color?.chat_text_color || this.getCookie("design_color_chat_text_color") || "#FFFF",
                "--smartphone_bg_color": this.design?.color?.smartphone_bg_color || this.getCookie("design_color_smartphone_bg_color") || "#FFFF",
                "--smartphone_text_color": this.design?.color?.smartphone_text_color || this.getCookie("design_color_smartphone_text_color") || "#FFFF",
                "--chat_bgheader_color": this.design?.color?.chat_bgheader_color || this.getCookie("design_color_chat_bgheader_color") || "#FFFF",
                "--headers_color_2nd": this.design?.color?.headers_color_2nd || this.getCookie("design_color_headers_color_2nd") || "#FFFF",
                "--highlight_color": this.design?.color?.highlight_color || this.getCookie("design_color_highlight_color") || "#FFFF",
                "--font_size": this.fontSizeReference[
                                 this.design?.font?.font_size || "medio"
                    ],
                "--footer_on": this.design?.footer_on ? "flex" : "none",
                "--multi_language_background": (this.logged || this.isGuest) ? (this.design?.color?.headers_color_logged || this.getCookie("design_color_headers_color_f") || '#FFFF') : (this.design?.color?.headers_color || this.getCookie("design_color_headers_color") || '#FFFF'),
            };
        },

        logoUrl() {
            if ((localStorage.getItem("eventmap")) && (localStorage.getItem("eventmap") != '')) {
                return this.eventlogo || localStorage.getItem("design_eventlogo") || logoDefault;
            } else
                return this.design?.logo || this.getCookie("design_logo") || logoDefault;
        },
        fontLink() {
            return this.design?.font?.font_link || this.getCookie("design_font_font_link") || this.$url_api + "fonts/Roboto.ttf";
        },
    },
    data() {
        return {
            buttons: {
                camera: "",
                notifications: "",
                radio_on: "",
                radio_off: "",
                menu: "",
                coins: "",
                points: "",
                badges: "",
                library: "",
                logoff: "",
                language: "",
                help: "",
            },
            openPackageAfterRegister: false,
            showTools: false,
            access_before_start: ['Signup', 'Login', 'Home', 'EventMap', 'TermosPage', 'EventLink', 'Support', "PublicRanking"],
            access_logged: ["Support", "PoliticaPage", "TermosPage"],
            logo_: null,
            fontSizeReference: {
                pequeno: "12px",
                medio: "14px",
                grande: "16px",
            },
            allowedExtensions: {
                images: ['jpg', 'jpeg', 'gif', 'png', 'tif', 'tiff', 'bmp']
            },
            openChatButton: false,
            modal_PoliticaDePrivacidade: false, modal_Wizard: false, modal_Termos: false, regulamento: false,
            modal_login_: false, photo_player: false, modal_cadastro_: false, modal_validacao_: false, modal_RememberPassword: false, modal_ResetPassword: false, modal_package: false, modal_package_buy: false, modal_guest_buy: false, modal_package_payments: false, modal_coins_buy: false, modal_ticket_gate: false, modal_package_single: false, modal_private_messages: false,
            chat: false, chat_max: 10, chat_audio: false, chat_participants: false, chat_interactive: true, tabname: '', modal_rewards: false, reward_message: '',
            reward_cta_button: '', reward_cta_label: '',
            descs: {
                "badges": {
                    active: true,
                    description: this.$i18n.t('app.vejaSeusBadges')
                },
                "guest": {
                    active: false,
                    description: this.$i18n.t('guest.criarContaDescription')
                },
                "logo": {
                    active: false,
                    description: this.$i18n.t('app.voltarAoMapa')
                },
                "nick": {
                    active: false,
                    description: this.$i18n.t('app.editeSuaConta')
                },
                "points": {
                    active: false,
                    description: this.$i18n.t('app.vejaSuaPosicao')
                },
                "coin": {
                    active: false,
                    description: this.$i18n.t('app.customizeSeuAvatar')
                },
                "selfie": {
                    active: false,
                    description: this.$i18n.t('app.tireSelfies')
                },
                "noti": {
                    active: false,
                    description: this.$i18n.t('app.leiaNotificacoes')
                },
                "menu": {
                    active: false,
                    description: this.$i18n.t('app.menuDeNavegacoes')
                },
                "radio": {
                    active: false,
                    description: this.$i18n.t('app.radio')
                },
                "shutoff": {
                    active: false,
                    description: this.$i18n.t('app.fazerLogout')
                },
                "guestShutoff": {
                    active: false,
                    description: this.$i18n.t('guest.fazerLogout')
                },
                "help": {
                    active: false,
                    description: this.$i18n.t('app.ajudaEContato')
                },
                "conteudo": {
                    active: false,
                    description: this.$i18n.t('app.conteudo')
                },
            },
            tools: true, //chat_room           : this.$route.name,
            chat_room: "",
            chat_owner: "",
            chat_not_clear: false,
            menu_active: false,
            terms: false,
            easter: false,
            baconmix: false,
            camera: false,
            easterId: 0,
            notification: false,
            notification_list: [],
            notification_request: false,
            notifications_count: 0,
            popup_notifications: 0,
            open_gallery: false,
            modal_: false,
            modal_badge_: false,
            modal_type: null,
            modal_title: null,
            modal_text: null,
            modal_response: null,
            modal_yes: null,
            modal_no: null,
            modal_btn: null,
            modal_iframe_url: null,
            modal_iframe: false,
            modal_iframe_type: null,
            modal_quest: null,
            session_access_type: 'ask',
            session_access: false,
            interval: null,
            focusUnityInterval: null,
            focusUnity:false,
            timer: false,
            library_title: "",
            windowWidth: window.innerWidth,
            ambient_transition: false,
            show_quiz: false,
            ticket_gate_ok: false,
            iframe_temp: false,
            iframe_temp_url: null,
            iframe_url: null,
            complaint: false,
            complaint_user_id: 0,
            ticket_actual: 0,
            count_inactivity: 0,
            count_inactivity_move: -1,
            iframecomponent: false,
            tutorial: false,
            live: false,
            age_get_user: false,
            login_date: null,
            radio: null,
            webcam_video: null,
            badge: {
                file_url: "",
                text: "",
                name: "",
                external_url: "",
            },
            webcam_canvas: null,
            webcam_canvas_context: null,
            webcam_stream: null,
            webcam_type: null,
            switch_avatar_new: false,
            group_active: null,
            conteudo: false,
            unity_video: null,
            options: [
                {
                    language: 'Português',
                    icon: '/assets/icons/header/brasil.svg',
                    code: "pt-br",
                    label: "-br",
                    active: true
                },
                {
                    language: 'Inglês',
                    icon: '/assets/icons/header/reino-unido.svg',
                    code: "en",
                    label: "",
                    active: true
                },
                {
                    language: 'Espanhol',
                    icon: '/assets/icons/header/espanha.svg',
                    code: 'es',
                    label: '',
                    active: true
                },
                {
                    language: 'Francês',
                    icon: '/assets/icons/header/french.svg',
                    code: 'fr',
                    label: '',
                    active: true
                }
            ],
            store_active: "vt",
            showAudioButton: false,
            control_audio: false,
            myVideoPlayer: null,
            isMobile: false,
            guest_id: 0,
            ticket_gate_id: null,
            ticket_gate_doesnt_exist: null,
            user_already_have_ticket: null,
            package_id: null,
            package_doesnt_exist: null,
            package_single: null,
            private_messages_friend_id: null,
            quest_id: null,
            quest_step_id: null,
            loading: false,
            loading_unity: null,
            RecurrentPayment: false,
            keyUnityConf: 'b9#xK4tL$pA7mDfR3^gH5@q2oZ8eN6jx',
            popUpPoints: false,
            popupInfo: {
                label_cta: '',
                url_cta: '',
                message: ''
            },
            is_lms_session: false,
            lms_session_name: null,
            html_template_: null,
            translucent_modals: [],
            //count_notify_points: 0
            play_wizard: null,
        };
    },
    components: {
        Share,
        Mural,
        SelfieController,
        CoinsBuy,
        GuestBuy,
        TicketGateModal,
        BtnPromotional,
        Popup,
        PoliticaDePrivacidade,
        Wizard,
        //Termos,
        RememberPassword,
        ResetPassword,
        EmailConfirmation,
        Signup,
        LoginAzure,
        LoginFacebook,
        LoginGoogle,
        ModalBadgesVue,
        Login,
        Mobile,
        EasterEgg,
        Camera,
        Notification,
        Modal,
        ModalIframe,
        SessionAccess,
        Chat,
        ChatAdmin,
        AmbientTransition,
        MusicPlayer,
        TicketGate,
        Group,
        Conteudo,
        Video,
        Oracle,
        VT,
        Vtex,
        Package,
        PackageBuy,
        PackagePayments,
        PackageSingle,
        PrivateMessages,
        Quest,
        Loading,
        ModalRewards,
        ModalPopupPoints,
        LmsHeader,
        LmsWebSocket,
        TranslucentModal
        // FileUploader,
    },
    methods: {
        addTranslucentModal({size= 'lg'/*lg sm*/, title= '', content= '',
                                confirm_text= '', cancel_text= '',
                                can_close= true, can_cancel= true, close_background= true,
                                callback= ()=>{},
                                callback_cancel= ()=>{},
                                callback_close= ()=>{}
        }){
            let id;
            if (this.translucent_modals.length === 0)
                id = 0;
            else
                id = this.translucent_modals
                    .reduce((prev, current) => (prev.id > current.id) ? prev : current).id;
            this.translucent_modals.push({
                id: id + 1,
                size, title, content, confirm_text, cancel_text,
                can_close, can_cancel,
                close_background, callback, callback_cancel,callback_close
            });
        },
        removeTranslucentModal(modal){
            let index = this.translucent_modals.findIndex(_=>_.id === modal.id);
            if(index !== -1){
                this.translucent_modals.splice(index, 1);
            }
        },
        createHTMLTemplate(html) {
            this.html_template_ = html;
            this.$store.dispatch('TemplateHTML/setHTMLTemplate', html);
            if (html) {
                this.setHTMLTemplate();
            } else {
                removeDivById('vt_template_html')
                this.$store.dispatch('TemplateHTML/setHTMLTemplateLoaded', false);
            }
        },
        setHTMLTemplate() {
            if (!this.template_html_loaded) {
                //CheckLogin
                if(this.html_template_.home_redirect) {
                    this.$router.push({ name: 'Login' });
                }
                // Set the inner HTML of the new element to your HTML string
                insertHtmlWithScript(this.html_template_.html);

                // Set loaded content
                this.$store.dispatch('TemplateHTML/setHTMLTemplateLoaded', true);
            }
        },
        showMobileTools() {
            this.showTools = !this.showTools
        },
        checkIsUser() {
            if (this.isGuest && this.switch.login_signup) {
                this.modal_cadastro_ = true;
            } else if (!this.isGuest) {
                this.exitLocal(this.profileExit)
            }
        },
        openFileManager() {
            this.file_uploader = true
            console.log('file uploader =>', this.file_uploader)
        },
        openPackage() {
            if (this.switch.finance_profile_menu) {
                // this.modal_package = true;
                this.modalsHandler();
                this.modal_package = (this.modal_coins_buy) ? false : true;
            }
        },
        allRelatedFriends() {
            const root = this;
            let headers = {
                "Content-Type": "application/json;charset=UTF-8",
                'Access': "application/json",
                'language': this.$i18n.locale,
                'Authorization': `Bearer ${this.token}`
            };
            axios
                .get(this.$url_api + "api/AllRelatedFriends", {headers: headers})
                .then((response) => {
                    root.$refs["chat"].addRelatedFriend(response.data);
                })
                .catch((error) => {
                    error
                });
        },
        createPlayer() {
            if (this.current_session.audio) {
                let url = new URL(this.current_session.audio)
                if (url.pathname.split('.')[1].indexOf("m3u8") !== -1) {
                    let root = this;
                    window.videojs('myVideoPlayer', {}, function () {
                        root.myVideoPlayer = this;
                        this.showAudioButton = true;
                    });
                } else {
                    this.$refs['audioPlay'].load();
                    this.showAudioButton = true;
                }
            }
        },
        headerButtons(obj) {
            for (let key in obj) {
                if (key == 'coins_button') {
                    obj[key] = obj[key].indexOf('black') !== -1
                        ? obj[key].replace(/black/g, 'white')
                        : obj[key].replace(/<svg/, '<svg fill="white"')
                } else {
                    obj[key] = obj[key].indexOf('black') !== -1
                        ? obj[key].replace(/black/g, 'var(--buttons_color)')
                        : obj[key].replace(/<svg/, '<svg fill="var(--buttons_color)"')
                }

                obj[key] = obj[key].indexOf('width') !== -1
                    ? obj[key].replace(/width="(\d{1,})"/g, 'width="$1"')
                    : obj[key].replace(/<svg/, '<svg width="20"')

                obj[key] = obj[key].indexOf('height') !== -1
                    ? obj[key].replace(/height="(\d{1,})"/g, 'height="$1"')
                    : obj[key].replace(/<svg/, '<svg height="20"')
            }
            this.update_header_buttons(obj)
        },
        audioPlay() {
            this.control_audio = true;
            if (this.myVideoPlayer) {
                this.myVideoPlayer.play();
            } else {
                this.$refs['audioPlay'].play();
            }
        },
        audioPause() {
            this.control_audio = false;
            if (this.myVideoPlayer) {
                this.myVideoPlayer.pause();
            } else {
                this.$refs['audioPlay'].pause();
            }
        },

        logoHandler() {
            if (localStorage.getItem("eventmap")) {
                this.logo_ = this.eventlogo || this.design?.logo || this.getCookie("design_logo") || logoDefault;
                this.logoFavicon_ = this.faviconLogo || this.design?.logoFavicon || this.getCookie("design_logo_favicon") || logoDefault;
            } else {
                this.logo_ = this.design?.logo || this.getCookie("design_logo") || logoDefault;
                this.logoFavicon_ = this.design?.logoFavicon || this.getCookie("design_logo_favicon") || logoDefault;
            }
            this.changeFavicon();
        },
        conteudoHandler(e) {
            if (e) e.preventDefault();
            //console.log'conteudo');
            this.analytics('library_btn')
            this.conteudo = true;
        },
        //----- moderator -----//
        moderatorHandler() {
            //console.log'aqui');
            this.group_active = true;
        },
        groupHandler() {
            //console.log'group_id => ', this.group_id, this.user_type);

            /*
                let session_group_ = [];
                for(let o in this.sessions)
                {
                    if (this.sessions[o].groups)
                    {
                        session_group_.push(this.sessions[o].name);
                    }
                }
                */
            let o;
            let id_room_;
            //console.log'groups => ', this.group_id, this.groups, ' _end');
            for (o in this.groups) {
                if ((this.groups[o].on) && (String(this.groups[o].id) == String(this.group_id))) {
                    id_room_ = this.groups[o].id_room;
                    break;
                }
            }
            //console.log'id_room_ => ', id_room_);
            for (o in this.sessions) {
                //if ((this.sessions[o].groups) && (this.sessions[o].room_id == id_room_) && (this.$route.path != ( '/e/' + this.sessions[o].name))) {
                if ((this.sessions[o].room_id == id_room_) && (this.$route.path != ( '/e/' + this.sessions[o].name))) {
                    if ((this.group_id) && (this.user_type == 'participant'))
                    {
                        //this.$router.push({path: ( '/e/' + this.sessions[o].name)});
                        window.location.href = this.$url + '#/e/' + this.sessions[o].name;
                    }
                break;
                }
            }
        },
        //----- moderator -----//
        //----- webcam-photo -----//
        webCamExit(e) {
            e;
            this.webcam_stream.getTracks().forEach((track) => track.stop());
            this.webcam_video.srcObject = null;

            try {
                this.webcam_canvas_context.clearRect(
                    0,
                    0,
                    this.webcam_canvas.width,
                    this.webcam_canvas.height
                );
            } catch (e) {
                e;
            }
            document.getElementById("webcam-photo").style.display = "none";
            document.getElementById("webcam-photo-discard").style.display = "none";
            document.getElementById("webcam-photo-save").style.display = "none";
            document.getElementById("webcam-photo-capture").style.display = "block";
        },
        webCamStart(webcam_type_) {
            this.webcam_type = webcam_type_;
            let root_ = this;

            navigator.mediaDevices
                .getUserMedia({video: true})
                .then(function (mediaStream) {
                    root_.webcam_stream = mediaStream;
                    root_.webcam_video = document.querySelector("#webcam-photo-video");
                    root_.webcam_video.srcObject = mediaStream;
                    root_.webcam_video.play();

                    document.getElementById("webcam-photo").style.display = "block";
                })
                .catch(function (err) {
                    err;
                    //console.log"Não há permissões para acessar a webcam.");
                });
        },
        getSetupWithPromise() {
            let $this = this;
            return new Promise((resolve, reject) => {
                axios
                    .get(this.$url_api + "api/setup", {
                        headers: {'language': this.$i18n.locale,},
                        params: { event: localStorage.getItem("eventmap"), slug_page: extractSceneNameFromURL(window.location.href) }
                    })
                    .then((response) => {
                        $this.getSetupResponse(response)
                        resolve(response)
                    }).catch(() => {
                    reject(console.log("Could Not resolve the setup"))
                })
            });
        },
        async getSetup() {
            return axios
                .get(this.$url_api + "api/setup", {
                    headers: {'language': this.$i18n.locale,},
                    params: {event: localStorage.getItem("eventmap"), slug_page: extractSceneNameFromURL(window.location.href)   }
                })
                .then((response) => this.getSetupResponse(response));
        },
        getSetupResponse(data) {
            this.show_captcha = (data && data.data && data.data.captcha && data.data.captcha == 1);
            this.tabname = data.data.Nome_Aba;
            if (this.$route.name == "Signup" && this.$route.query._ === "84502530") {
                data.data.waiting_mode = false;
            }
            this.update_switch(data.data);
            console.log('switch =>', this.switch)

            if (this.switch.multilanguages && this.switch.active_languages && Object.keys(this.switch.active_languages).length > 0) {
                this.options = this.options.map(option => {
                    const languageCode = option.code;
                    const isActive = this.switch.active_languages[languageCode];

                    option.active = isActive === 1;

                    return option;
                });
            }

            this.setCookie("switch_Nome_Aba", this.switch.Nome_Aba)

            this.createHTMLTemplate(data.data.html_template);

            // caso o admin mude para nao habilitar o multilingua, força o usuário que estava em outra lingua para a lingua padrao
            if( !this.switch.multilanguages ) {
                this.$i18n.locale = this.switch.default_language;
                localStorage.setItem('language', this.$i18n.locale);
                localStorage.removeItem('userSettedLanguage');
            } else {
                if( !localStorage.getItem('userSettedLanguage') ) {
                    this.$i18n.locale = this.switch.default_language;
                    localStorage.setItem('language', this.$i18n.locale);
                    localStorage.setItem('userSettedLanguage', this.$i18n.locale);
                }
            }

        },
        fillDescs() {
            this.descs = {"badges": {
                    active: true,
                    description: this.$i18n.t('app.vejaSeusBadges')
                },
                "guest": {
                    active: false,
                    description: this.$i18n.t('guest.criarContaDescription')
                },
                "logo": {
                    active: false,
                    description: this.$i18n.t('app.voltarAoMapa')
                },
                "nick": {
                    active: false,
                    description: this.$i18n.t('app.editeSuaConta')
                },
                "points": {
                    active: false,
                    description: this.$i18n.t('app.vejaSuaPosicao')
                },
                "coin": {
                    active: false,
                    description: this.$i18n.t('app.customizeSeuAvatar')
                },
                "selfie": {
                    active: false,
                    description: this.$i18n.t('app.tireSelfies')
                },
                "noti": {
                    active: false,
                    description: this.$i18n.t('app.leiaNotificacoes')
                },
                "menu": {
                    active: false,
                    description: this.$i18n.t('app.menuDeNavegacoes')
                },
                "radio": {
                    active: false,
                    description: this.$i18n.t('app.radio')
                },
                "shutoff": {
                    active: false,
                    description: this.$i18n.t('app.fazerLogout')
                },
                "guestShutoff": {
                    active: false,
                    description: this.$i18n.t('guest.fazerLogout')
                },
                "help": {
                    active: false,
                    description: this.$i18n.t('app.ajudaEContato')
                },
                "conteudo": {
                    active: false,
                    description: this.$i18n.t('app.conteudo')
                },
            }
        },
        getSetupResponseWithPromise() {
            return new Promise((resolve) => {
                this.getSetupWithPromise().then(data => {
                    this.show_captcha = (data && data.data && data.data.captcha && data.data.captcha == 1);
                    this.tabname = data.data.Nome_Aba;
                    if (this.$route.name == "Signup" && this.$route.query._ === "84502530") {
                        data.data.waiting_mode = false;
                    }
                    this.getSetupResponse(data);
                    //   this.update_switch(data.data);
                    this.setCookie("switch_Nome_Aba", this.switch.Nome_Aba);
                    resolve();
                })
            })
        },
        webCamCapture(e) {
            e;
            this.webcam_canvas = document.querySelector("#webcam-photo-canvas");
            this.webcam_canvas.height = this.webcam_video.videoHeight;
            this.webcam_canvas.width = this.webcam_video.videoWidth;
            this.webcam_canvas_context = this.webcam_canvas.getContext("2d");
            this.webcam_canvas_context.drawImage(this.webcam_video, 0, 0);

            /*if (this.webcam_type == 'webcam_photo') {
                // document.getElementById("iframe").contentWindow.SelfieReady(this.webcam_canvas.toDataURL("image/png"));
                this.sendToUnity('SelfieReady', { data: this.webcam_canvas.toDataURL("image/png") });
            }*/
            document.getElementById("webcam-photo-capture").style.display = "none";
            document.getElementById("webcam-photo-discard").style.display = "block";
            document.getElementById("webcam-photo-save").style.display = "block";
        },
        webCamDiscard(e) {
            e;

            this.webcam_canvas_context.clearRect(
                0,
                0,
                this.webcam_canvas.width,
                this.webcam_canvas.height
            );
            document.getElementById("webcam-photo-discard").style.display = "none";
            document.getElementById("webcam-photo-save").style.display = "none";
            document.getElementById("webcam-photo-capture").style.display = "block";
        },
        webCamSave(e) {
            e;
            if (this.webcam_type == 'avatarsdk') {
                this.webcam_type = null;
                this.sendToUnity('SelfieReady', { data: this.webcam_canvas.toDataURL("image/png") });
                this.webCamExit(null);
                /*this.modal(
                    "status",
                    "Ok!",
                    this.$i18n.t('app.fotoCapturada'),
                    null,
                    null,
                    null,
                    "OK"
                );*/
            } /*else {
                this.wait(true);
                //var canvas = document.querySelector("#canvas");
                let root_ = this;
                let canvas_data = this.webcam_canvas.toDataURL("image/jpeg");
                var form_data = new FormData();
                form_data.append("image", canvas_data);

                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    Access: "application/json",
                    language: this.$i18n.locale, Authorization: `Bearer ${root_.token}`,
                };
                axios
                    .post(root_.$url_api + "api/user/sendWebCamPhoto", form_data, {
                        headers: headers,
                    })
                    .then((response) => root_.webCamSaveResponse(response))
                    .catch((error) => root_.webCamSaveError(error.response));
                /!*
                      this.webcam_canvas.toBlob(function (blob) {

                          var form_data = new FormData();
                          form_data.append('image', blob, 'webcam.jpg');

                          let headers = {
                              'Content-Type': 'application/json;charset=UTF-8',
                              'Access': 'application/json',
                              language: this.$i18n.locale, Authorization: `Bearer ${root_.token}`
                          };
                          axios.post(root_.$url_api + 'api/user/sendWebCamPhoto', form_data, { headers: headers }).then(response => root_.webCamSaveResponse(response)).catch(error => root_.webCamSaveError(error.response));

                      }, 'image/jpeg');
                      *!/
            }*/
        },
        webCamSaveResponse(obj) {
            obj;
            //console.log"webCamSaveResponse => ", obj);
            if (obj.data.success == "ok") {
                this.modal(
                    "status",
                    this.$i18n.t('app.info'),
                    this.$i18n.t('app.fotoSalva'),
                    null,
                    null,
                    null,
                    "OK"
                );
                this.webCamExit(null);
            }
            this.wait(false);
        },
        webCamSaveError(obj) {
            obj;
            //console.log"webCamSaveError => ", obj);
            this.wait(false);
        },
        //----- \webcam-photo\ -----//
        IOSInfo() {
            this.modal("status", this.$i18n.t('app.info'),
                this.$i18n.t('app.versaoIOS'),
                null, null, null, "OK");
        },
        video_pp(e) {
            e;
            //document.getElementById('iframe').contentWindow.document.getElementsByTagName('iframe')[0].contentWindow.document.getElementById('iframe').contentWindow.pp();
            //let data = { type:'pp' };
            //document.getElementById('iframe').contentWindow.document.getElementsByTagName('iframe')[0].contentWindow.document.getElementById('iframe').contentWindow.callingVuejsFunctionVideo(data);
            focusUnity(this.checkMobile);
            let frame = document
                .getElementById("iframe")
                .contentWindow.document.getElementsByTagName("iframe")[0];

            //frame.contentWindow.postMessage(data, 'https://sysnba.vrglass.com');
            frame.contentWindow.p();
        },
        video_fs(e) {
            e;
            //let data = { type:'fs' };
            //document.getElementById('iframe').contentWindow.document.getElementsByTagName('iframe')[0].contentWindow.document.getElementById('iframe').contentWindow.callingVuejsFunctionVideo(data);
            document.getElementById("iframe").click();
            let frame = document
                .getElementById("iframe")
                .contentWindow.document.getElementsByTagName("iframe")[0];
            frame.click();
            frame.contentWindow.f();
            //frame.contentWindow.postMessage(data, 'https://sysnba.vrglass.com');
        },
        setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        deleteCookie(name) {
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },
        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        wizardHandler()
        {
            this.play_wizard = false;
            // console.log('this.design.wizard.play => ', this.design.wizard.play, localStorage.getItem('wizard_check'));
            if (this.design && this.design.wizard)
            {
                if ((this.design.wizard.play == 1) && (!this.design.wizard_check))
                {
                    this.play_wizard = true;
                }
                else if ((this.design.wizard.play == 2) && (!localStorage.getItem('wizard_check')))
                {
                    localStorage.setItem('wizard_check', 1);
                    this.play_wizard = true;
                }
            }

            if (this.play_wizard)
            {
                switch (this.$route.name)
                {
                    case "Map":
                        if (this.design.wizard && this.design.wizard.play > 0 && this.design.wizard.title!=="" && this.design.wizard.url!=="")
                        {
                            if ( (this.checkMobile || this.checkIOS) && this.design.wizard.url_mobile)
                                this.modalI(this.design.wizard.title, this.design.wizard.url_mobile);
                            else
                                this.modalI(this.design.wizard.title, this.design.wizard.url);
                            break;
                        }
                        else
                        {
                            break;
                        }
                    case "Account":
                    case "Profile":
                    case "TicketPurchased":
                    case "VipRoom":
                    case "Support":
                    case "Friends":
                    case "FriendsInvited":
                    case "City":
                    case "Ranking":
                    case "Ticket":
                    case "Partners":
                    case "FanZone":
                    case "PlayZone":
                    case "FeelZone":
                    case "Store":
                    case "Museum":
                    case "LockerRoom":
                    case "Iframe":
                        this.modal_Wizard = true;
                    break;
                    default:
                        this.modal_Wizard = false;
                    break;
                }
            }
        },
        /*
        wizardHandler() {
            //aparecer tutorial sempre q for para o mapa
            if (this.$route.name === "Map" && this.design.wizard && this.design.wizard.play !== 0 && this.design.wizard.title!=="" && this.design.wizard.url!=="" && this.design.wizard_check == null){
                if (this.design.wizard.play == 1){
                    this.setCookie(
                        this.$route.name.toLowerCase() + "_wizard",
                        "wizard",
                        30
                    );
                }
                if ( (this.checkMobile || this.checkIOS) && this.design.wizard.url_mobile)
                    this.modalI(this.design.wizard.title, this.design.wizard.url_mobile);
                else
                    this.modalI(this.design.wizard.title, this.design.wizard.url);
                return;
            }
            let cookie = this.getCookie(this.$route.name.toLowerCase() + "_wizard");
            if (cookie == "") {
                switch (this.$route.name) {
                    case "Map":
                        if (this.design.wizard && this.design.wizard.play == 1  && this.design.wizard.title!=="" && this.design.wizard.url!=="") {
                            if ( (this.checkMobile || this.checkIOS) && this.design.wizard.url_mobile)
                                this.modalI(this.design.wizard.title, this.design.wizard.url_mobile);
                            else
                                this.modalI(this.design.wizard.title, this.design.wizard.url);
                            this.setCookie(
                                this.$route.name.toLowerCase() + "_wizard",
                                "wizard",
                                30
                            );
                            break;
                        } else {
                            break;
                        }
                    case "Account":
                    case "Profile":
                    case "TicketPurchased":
                    case "VipRoom":
                    case "Support":
                    case "Friends":
                    case "FriendsInvited":
                    case "City":
                    case "Ranking":
                    case "Ticket":
                    case "Partners":
                    case "FanZone":
                    case "PlayZone":
                    case "FeelZone":
                    case "Store":
                    case "Museum":
                    case "LockerRoom":
                    case "Iframe":
                        this.modal_Wizard = true;
                        this.setCookie(
                            this.$route.name.toLowerCase() + "_wizard",
                            "wizard",
                            30
                        );
                        break;
                    default:
                        this.modal_Wizard = false;
                        break;
                }
            }
        },
        */
        openChatMobile() {
            this.openChatButton = !this.openChatButton;
        },
        tutorialHandler(e) {
            e;
            this.analytics("tutorial_home");
            this.tutorial = !this.tutorial;
        },
        aoVivoHandler() {
            for (let o = 0; o < this.EventimTickets.length; o++) {
                if (this.EventimTickets[o].state == "Ao vivo") {
                    this.live = true;
                    return;
                }
            }
            this.live = false;
        },
        //----- \header descriptions\ -----//
        showDesc: function (type) {
            //console.logtype);
            this.descs[type].active = true;
        },
        hideDesc: function (type) {
            this.descs[type].active = false;
        },
//----- analytics -----//
        //event_name(string)
        //data(object)
        mobileCloseExit(value) {
            if (value == 1) {
                this.mobileClose();
                this.link("Map");
                this.iframecomponent = false;
            }
        },
        pointsExit(value) {
            if (value == 1) {
                if(this.switch.event_menu && this.switch.event_menu['ranking_pontos']) {
                    this.link("Ranking");
                    this.iframecomponent = false;
                }
            }
        },
        profileExit(value) {
            if (value == 1) {
                this.link("Profile");
                this.iframecomponent = false;
            }
        },
        coinsExit(value) {
            if (value == 1) {
                this.link("Ticket");
                this.iframecomponent = false;
            }
        },
        exitLocal(response) {
            if (this.iframecomponent) {
                this.modal(
                    "confirmation",
                    this.$i18n.t('app.atencao'),
                    this.$i18n.t('app.desejaRealmente'),
                    response,
                    this.$i18n.t('app.sim'),
                    this.$i18n.t('app.nao')
                );
            } else {
                response(1);
            }
        },
        getImageTeam(team) {
            if (team != null)
                return (
                    this.$url +
                    "assets/images/" +
                    team
                        .trim()
                        .split(" ")[0]
                        .toUpperCase() +
                    ".png"
                );
        },
        getLastRoom() {
            let id_last_room = 0;
            if (localStorage.getItem("user")) {
                let user = JSON.parse(localStorage.getItem("user"));
                id_last_room = user.id_vip_actual;
            }
            return id_last_room;
        },
        inactivityConfirm(r) {
            if (r === 1) {
                this.count_inactivity = 0;
                this.count_inactivity_move = -1;
            }
        },
        checkInactivity() {
            this.count_inactivity++;
            ///console.log(this.count_inactivity);
            if (this.count_inactivity >= 3600) {
                switch (this.$route.name) {
                    case "Iframe":
                        this.count_inactivity = 0;
                        this.count_inactivity_move = 30;
                        this.modal(
                            "confirmation",
                            this.$i18n.t('app.ei'),
                            this.$i18n.t('app.voceAinda'),
                            this.inactivityConfirm
                        );
                        break;
                }
            }

            if (this.count_inactivity_move > 0) {
                this.count_inactivity_move--;
                try {
                    this.$refs["modal"].$refs["text-info"].innerHTML =
                        '<p style="text-align:center">' + this.$i18n.t('app.voceAinda') + '<br>' +
                        this.count_inactivity_move +
                        "</p>";
                } catch (e) {
                    //
                }
            } else if (this.count_inactivity_move == 0) {
                this.modal_ = false;
                this.count_inactivity = 0;
                this.count_inactivity_move = -1;
                switch (this.$route.name) {
                    case "Iframe":
                        this.link("Map");
                        break;
                }
            }
        },
        analytics(event_name, data) {
            event_name, data;
            //page, event, data;
            if (this.$gtag) {
                this.$gtag.event(event_name);
            }
            if (window._mtm && window._mtm.length > 0){
                let newData = data;
                try {
                    if (data && typeof data === 'object' && !Array.isArray(data)){
                        newData = JSON.stringify(data);
                    } else if (data && Array.isArray(data)){
                        newData = JSON.stringify(data);
                    } else if (!data){
                        newData = "CustomEvent";
                    }
                }catch (e){
                    e;
                    newData = "CustomEvent";
                }
                let mtmData = {'event': 'VTCustomEvent', 'mtm.category':event_name, 'mtm.name':event_name, 'mtm.localdata':newData};
                window._mtm.push(mtmData);
            }
            //console.log('analytics => ', event_name, data);
        },
        //----- \analytics\ -----//
        modal(type, title, txt, response, y, n, b, iframe) {
            this.modal_type = type;
            this.modal_title = title;
            this.modal_text = txt;
            this.modal_response = response;
            this.modal_yes = y;
            this.modal_no = n;
            this.modal_btn = b;
            this.modal_iframe_url = iframe;
            this.modal_ = true;
        },
        checkIsImage(s) {
            return (s.substring(s.length - 3) == 'png' || s.substring(s.length - 3) == 'jpg' || s.substring(s.length - 3) == 'gif' || s.substring(s.length - 4) == 'jpeg');
        },
        modalI(title, iframe, response, type = "") {
            this.modal(
                (this.checkIsImage(iframe) ? "image" : "iframe") + (type ? "_" + type : ""),
                title,
                null,
                response,
                null,
                null,
                null,
                iframe);
        },
        modalIframe(type) {
            this.modal_iframe_type = type;
            this.modal_iframe = true;
        },
        finishForm(ev) {
            if (ev && ev.data && ev.data.message){
                if (ev.data.message == 'close_form') {
                    setTimeout(() => {
                        this.modal_iframe = false
                        this.modal_ = false
                        document.getElementById('iframe').contentWindow.postMessage({message_type:"external",data: "krpano_modal", params: {}}, '*')
                    }, 1500)
                }
            }
        },
        sessionAccess(type) {
            this.session_access_type = type;
            this.chat = false
            this.switch_avatar_new = false;
            this.ambient_transition = false;
            this.session_access = true;
        },
        bodyOverflow(change = true) {
            let element = document.getElementsByTagName("body")[0];
            if (change) {
                element.style.overflow = "hidden";
                return;
            }
            element.style.overflow = "auto";
        },
        checkAge() {
            if (this.age >= 18) return true;
            else return false;
        },
        checkLive() {
            let count_live = 0;
            for (let o = 0; o < this.EventimTickets.length; o++) {
                if (this.EventimTickets[o].state == "Ao vivo") {
                    count_live++;
                }
            }
            if (count_live > 0) return true;
            else return false;
        },
        ...mapActions([
            "update_logged", "update_id", "update_token", "update_email", "update_profile",
            "update_started", "update_url_actual", "update_age_verified", "update_email_verified",
            "update_coin", "update_point", "update_totalbadges", "update_dat", "update_notifications", "update_notifications_count", "update_switch",
            "update_user_tickets_del", "update_eventim_tickets", "update_sessions", "update_guest",
            "update_change_password_social", "update_webview", "update_groups","update_id_form_actual",
            "update_current_session", "update_design", "update_stores","update_notification_datas", "update_checkers", "update_quest",
            "update_notifications_private_message", "update_notifications_del", "update_user_picture", "update_reward_slug", "update_use_avatar", "update_avatar_metaverse",
            "update_notifications_notify_points", "update_header_buttons","update_type_validation", "update_login_social",
            "reset_unity_hash_log","update_time_unity_hash_log",
            "update_radio", "update_notifications_pendent_ids"
        ]),
        wait(b, unity_ = null) {
            // this.$refs["loader"].style.display = b ? "block" : "none";

            // if ((b == false) && (this.loading_unity == true))
            if (unity_ != null)
            {
                // if (unity_ === true)
                this.loading = b;
                this.loading_unity = b;
            }
            else
            {
                if (!this.loading_unity)
                {
                    this.loading = b;
                }
            }

            //console.log('WAIT => ', b, this.loading_unity);
        },
        menuMobileHandler() {
            console.log(this.menu_active);
            this.menu_active = !this.menu_active;
            console.log(this.menu_active);
            document.getElementById("menu").style.display = this.menu_active
                ? "flex"
                : "none";
        },
        varifyLoggedError(error) {
            if (error.status == 401 || error.message == "Unauthenticated.") {
                this.logoutEnd();
            }
        },
        //----- saveUser -----//
        saveUser(dat_) {
            localStorage.setItem("user", JSON.stringify(dat_));
        },
        updateUser(attribute, v) {
            let data_temp = localStorage.getItem("user");
            data_temp = JSON.parse(data_temp);
            data_temp[attribute] = v;
            localStorage.setItem("user", JSON.stringify(data_temp));
        },
        //----- \saveUser\ -----//
        //----- logout -----//
        logout() {
            if(this.isGuest){
                this.modal("confirmation", this.$i18n.t('app.atencao'), this.$i18n.t('guest.fazerLogout'), this.logoutConfirmation);
            } else {
                this.modal("confirmation", this.$i18n.t('app.atencao'), this.$i18n.t('app.desejaRealmenteSair'), this.logoutConfirmation);
            }
            this.$store.dispatch("signup/reset");
            let eventName = new Event("closeMenu");
            document.dispatchEvent(eventName);
        },
        logoutConfirmation(r) {
            if (r === 1) {
                this.analytics("logout_btn");
                this.wait(true);
                let form_data = new FormData();
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access': "application/json",
                    'language': this.$i18n.locale,
                    'Authorization': `Bearer ${this.token}`
                };
                axios
                    .post(this.$url_api + "api/logout", form_data, {headers: headers})
                    .then((response) => this.logoutResponse(response))
                    .catch((error) => this.logoutError(error.response));
            }
        },
        logoutResponse(obj) {
            obj;
            this.logoutEnd();
            this.wait(false);
        },
        logoutError(obj) {
            this.varifyLoggedError(obj.data);
            this.wait(false);
        },
        logoutEnd() {
            /*
                  window.FB.logout(function(response) {
                      console.log(response);
                      // user is now logged out
                  });
                  */


            //localStorage.removeItem("eventmap");
            //localStorage.removeItem("eventSessionLink");
            if (typeof window._paq == "object") {
                window._paq.push(["resetUserId"]);
            }
            localStorage.removeItem("user");
            this.deleteCookie("guest_last_join");
            localStorage.removeItem("design_eventlogo");

            this.update_logged(false);
            this.update_started(false);
            if (this.isGuest) {
                this.update_guest(false)
                localStorage.removeItem("guest")
            }
            this.update_token(null);
            // this.link("Home");

            localStorage.removeItem('wizard_check');
            localStorage.removeItem('redirectPath');
            localStorage.removeItem('userSettedLanguage');
            this.modal_private_messages = false;

            this.getSetup();

            if ((localStorage.getItem("eventmap")) && (localStorage.getItem("eventmap") != ''))
            {
                window.location.href = this.$url + '#/evento/' + localStorage.getItem("eventmap");
            }
            else {
                console.log('caindo no redirect do eventmap :: 2')
                this.$router
                    .push({ path: '/' })
                    .then(() => {
                        this.$router.go();
                    });
            }

            if (this.switch.without_landing_page == 'without_landing_page') {
                // location.reload(true)
                this.createGuest()
            }
        },
        changeGuest() {
            this.analytics("logout_btn");
            this.wait(true);
            let form_data = new FormData();
            let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access': "application/json",
                    'language': this.$i18n.locale,
                    'Authorization': `Bearer ${this.token}`
                };
            axios
                .post(this.$url_api + "api/logout", form_data, {headers: headers})
                .catch((error) => this.logoutError(error.response));

        },
        createGuestVerifyCaptcha() {
            if(this.switch.captcha) {
                this.modal("confirmationCaptcha", this.$i18n.t('guest.titulo-captcha'),
                this.$i18n.t('guest.desc-captcha'), this.createGuest, this.$i18n.t('guest.confirmar'), this.$i18n.t('guest.cancelar'));
            } else {
                this.createGuest();
            }
        },
        createGuest(status, captcha) {
            if(status == 0) {
                return;
            }
            this.wait(true)
            let headers = {
                "Content-Type": "application/json;charset=UTF-8",
                'Access': "application/json",
                'language': this.$i18n.locale,
            };
            let form_data = new FormData();
            form_data.append('g-recaptcha-response', captcha)
            axios
                .post(this.$url_api + "api/loginAsGuest", form_data, {headers: headers})
                .then((response) => this.createGuestResponse(response))
                .catch((error) => this.createGuestError(error.response));
        },
        async createGuestResponse(response) {
            this.login_date = new Date();
            this.update_id(response.data.id);
            this.update_logged(false);
            this.update_guest(true);
            localStorage.setItem('guest', 'on')
            this.update_token(response.data.token);
            this.update_email_verified(true);
            await this.getUser();
            console.log('chegando no guest')
            this.link('Map');
            console.log('redirecionando guest')
            // location.reload(true);
        },
        createGuestError(response) {
            if (
                response.data.message == "erro_desconhecido" ||
                response.data.status == "error"
            ) {
                let str = "";
                for (let o in response.data.errors) {
                    str += response.data.errors[o] + "\n";
                }
                this.modal("error", response.data.message, str, null, null, null, "OK");
            }
            this.wait(false);
        },
        //----- \logout\ -----//
        //----- delete -----//
        deleteAccount() {
            if(this.RecurrentPayment) {
                alert(this.$i18n.t('app.recurrentPayment'));
            } else {
                this.modal("confirmationCaptcha", this.$i18n.t('app.atencao'),
                    this.$i18n.t('app.aoConfirmar'), this.deleteAccountConfirmation);
            }

        },
        deleteAccountConfirmation(r, gcaptcha) {
            if (r === 1) {
                this.wait(true);
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    Access: "application/json",
                    language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
                };
                let data = {"g-recaptcha-response": gcaptcha};
                axios.delete(this.$url_api + "api/user", {
                    headers: headers,
                    data: data,
                }).then((response) => this.deleteAccountResponse(response))
                    .catch((error) => this.deleteAccountError(error.response));
            }
        },
        deleteAccountResponse(obj) {
            obj;
            this.update_checkers(0);
            this.$store.dispatch("signup/reset")
            this.logoutEnd();
            this.wait(false);
        },
        deleteAccountError(obj) {
            if (obj.data.message == "winner_not_delete") {
                this.modal("error", this.$i18n.t('app.erro'), obj.data.error, null, null, null, "OK");
            } else if (obj.data.message == "The given data was invalid.") {
                this.modal("error", this.$i18n.t('app.erro'), this.$i18n.t('app.vocePrecisa'),
                    this.deleteAccount, null, null, "OK");
            }
            this.varifyLoggedError(obj.data);
            this.wait(false);
        },
        openSelfieModal(){
            this.analytics("selfie_btn");
            this.$refs["selfieControl"].open();
        },
        //----- \delete\ -----//
        updatePopupNotifications(){
            this.notification_list = this.NotificationsList;
            this.popup_notifications = this.notification_list.filter(_=>_.popup && _.show_popup);
        },
        refreshNotificationPrivateMessages(friend_id){
            let index = Object.keys(this.notification_list).find(x => this.notification_list[x].friend_id === friend_id && this.notification_list[x].type == "private_message" );
            this.update_notifications_del(index);
        },

        /* LMS */
        LMSHandler(is_lms, origin__ = '', event__ = '', session__ = '')
        {
            console.log('is_lms => ', is_lms);
            if (origin__ == 'map')
            {
                console.log('DIRECIONAMENTO MAP', this.$route.name);
                // if (is_lms && this.$route.name != 'LmsHome') {
                if (is_lms) {
                    this.is_lms_session = false;
                    this.$router.push({path: `/lms/${is_lms.slug}`});
                }
            }
            else if ((origin__ == 'app') && (event__ == '') && (session__ == ''))
            {

                if (is_lms && (this.$route.name == 'Home')) {
                    console.log('ENTROU NO IF 1 --------------------');
                    this.is_lms_session = false;
                    this.$router.push({path: `/lms/${is_lms.slug}`});
                }
                else if(is_lms && this.$route.name == 'EventMap') {
                    console.log('ENTROU NO IF 2 --------------------');
                    this.is_lms_session = false;
                    this.$router.push({path: `/lms/${is_lms.slug}`});
                }
                else if (is_lms && (this.$route.name != 'LmsHome' || this.is_lms_session)) {

                    let index       = this.sessions.map(e => e.name).indexOf(this.lms_session_name);
                    let course_id   = this.sessions[index].course_id;
                    let index2      = Object.keys(is_lms.courses).find(
                        x => is_lms.courses[x].id === course_id
                    );
                    let slug        = is_lms.courses[index2].slug;
                    // console.log('sssssssssssssssssssssssssss', index2, slug);

                    this.$router.push({path: `/lms/${is_lms.slug}/${slug}`});
                }
                else if(is_lms && (this.$route.name != 'LmsHome' && !this.is_lms_session)) {
                    console.log('ENTROU NO IF 4 --------------------');
                    this.is_lms_session = false;
                    this.$router.push({path: `/lms/${is_lms.slug}`});
                }
            }
            else if ((origin__ == 'app') && (event__ != ''))
            {
                //direcionar aqui evento
                if (is_lms && this.$route.name != 'LmsHome') {
                    this.is_lms_session = false;
                    this.$router.push({path: `/lms/${is_lms.slug}`});
                }
            }
            else if ((origin__ == 'app') && (session__ != ''))
            {
                this.is_lms_session = true;
                this.lms_session_name = session__;
                if (is_lms && this.$route.name != 'LmsHome')
                    // this.$router.push({name: 'LMSCourses'});
                    this.$router.push({path: `/lms/${is_lms.slug}/courseSlug`}); // <-- rever isso
            }
        },
        //----- user-info -----//
        getUser() {
            //console.log'eventmap => ', localStorage.getItem("eventmap"));
            this.wait(true);
            let headers = {
                "Content-Type": "application/json;charset=UTF-8",
                'Access': "application/json",
                'language': this.$i18n.locale,
                'Authorization': `Bearer ${this.token}`
            };
            return axios
                .get(this.$url_api + "api/welcome", {headers: headers, params: { eventmap: localStorage.getItem("eventmap") } })
                .then((response) => this.getUserResponse(response))
                .catch((error) => this.getUserError(error.response));
        },
        getUserResponse(obj) {
            /* LMS */
            this.$store.dispatch("signup/reset")
            let dat = new Date(obj.data.dat);
            let id_last_room_ = this.getLastRoom();
            if (id_last_room_ > 0) {
                this.chat_room = "BarVip" + id_last_room_;
                this.chat_owner =
                    JSON.parse(localStorage.getItem("user")).owner_vip_actual +
                    " " +
                    id_last_room_;
                obj.data.id_vip_actual = id_last_room_;
                obj.data.owner_vip_actual = JSON.parse(
                    localStorage.getItem("user")
                ).owner_vip_actual;
            }
            this.eventlogo = obj.data.logo;
            this.logoHandler();
            obj.data.dat = dat;
            obj.data.token = this.token;
            obj.data.email_verified = this.email_verified;
            obj.data.id = this.id;
            if (typeof window._paq == "object") {
                window._paq.push(["setUserId", obj.data.email]);
            }
            this.notifications_count = obj.data.notification_count;
            this.RecurrentPayment = obj.data.RecurrentPayment;
            this.update_notifications(obj.data.NotificationsList);
            this.update_notifications_count(obj.data.notification_count);
            this.update_notifications_pendent_ids(obj.data.notification_pendent_ids);
            this.updatePopupNotifications()
            this.update_age_verified(obj.data.birth_day == false ? false : true);
            this.update_profile(obj.data);
            this.update_use_avatar(obj.data.use_avatar);
            this.update_avatar_metaverse(obj.data.avatar_metaverse);
            this.update_user_picture(obj.data.custom_profile_photo)
            if(obj.data.is_guest) {
                this.update_guest(true);
                this.update_logged(false);
                this.setCookie("guest_last_join", obj.data.last_acess);
            } else {
                this.update_guest(false);
                this.update_logged(true);
            }
            this.setCookie("switch_Nome_Aba",this.switch.Nome_Aba)
            if (
                obj.data.birth_day == false &&
                this.$route.name !== "EmailConfirmation"
            )
            {
                this.link("Age");
            }
            this.saveUser(obj.data);
            try
            {
                this.$refs["mobile"].refreshMenu();
            } catch(e) { e; }
            this.update_dat(dat);
            this.update_groups(obj.data.groups);
            // this.groupHandler();
            this.update_started(true);
            //temp
            //this.checkVideoAvatar(this.$route.name);

            this.radio = obj.data.radio;
            this.update_radio(this.radio);

            this.switch.multilanguages = obj.data.Multilanguage;
            this.switch.active_languages = obj.data.switch.active_languages;
            this.switch.default_language = obj.data.switch.default_language;

            // caso o admin mude para nao habilitar o multilingua, força o usuário que estava em outra lingua para a lingua padrao
            if( !this.switch.multilanguages ) {
                this.$i18n.locale = this.switch.default_language;
                localStorage.setItem('language', this.$i18n.locale);
                localStorage.removeItem('userSettedLanguage');
            } else {
                if( !localStorage.getItem('userSettedLanguage') ) {
                    console.log('Trocando para a lingua padrao');
                    this.$i18n.locale = this.switch.default_language;
                    localStorage.setItem('language', this.$i18n.locale);
                    localStorage.setItem('userSettedLanguage', this.$i18n.locale);
                }
            }
            this.fillDescs();

            this.update_switch(obj.data.switch)

            // this.LMSHandler(obj.data.lms??false, 'app', '', '');
            if(this.switch.multilanguages && this.switch.active_languages && Object.keys(this.switch.active_languages).length > 0) {
                this.options = this.options.map(option => {
                    const languageCode = option.code;
                    const isActive = this.switch.active_languages[languageCode];

                    option.active = isActive === 1;

                    return option;
                });
            }

            this.wizardHandler();
            this.wait(false);

            if(this.openPackageAfterRegister) {
                this.openPackage();
                this.openPackageAfterRegister = false;
            }
        },
        getUserError(obj) {
            if (obj) {
                this.varifyLoggedError(obj.data);
                this.wait(false);
                // this.logout();
            }
        },
        //----- \user-info\ -----//
        stopSound() {
            try {
                //console.log('playinf => ', document.getElementById('player-iframe').contentWindow.audio_active);
                if (document.getElementById("player-iframe").contentWindow.audio_active)
                    document.getElementById("player-iframe").contentWindow.playPause();
            } catch (e) {
                e;
            }
        },
        //----- link -----//
        link(url) {
            if (this.$route.name != url) {
                this.$router.push({name: url});
            }
        },
        //----- link -----//

        //----- sendToUnity -----//
        sendToUnity(event_type, unity_data)
        {
            this.analytics('sendToUnity', event_type)
            try {
                document.getElementById("iframe").contentWindow.SendMessageToUnity(event_type, unity_data);
            } catch ({error}) {
                try {
                    document.getElementById("iframe").contentWindow.postMessage({type:"SendMessageToUnity",event_type,unity_data}, "*");
                }catch ({e2}) {
                    console.log('sendToUnity error');
                }
            }

        },
        //----- \sendToUnity\ -----//

        xor_this(str, key) {
            let result = '';
            for (let i = 0; i < str.length; i++) {
                const charCode = str.charCodeAt(i) ^ key.charCodeAt(i % key.length);
                result += String.fromCharCode(charCode);
            }
            return result;
        },

        async openExternalGame(hash)
        {
            this.wait(true);
            if (hash.game_rule && hash.game_rule.endpoint)
            {
                // crediting
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    Access: "application/json",
                    language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
                };
                let payload = {
                    mt: this.token,
                    score: 0,
                    winner:0
                };
                payload = btoa(this.xor_this(JSON.stringify(payload), 'fd6c3063050bf91635a40f54836774f7296704f206db25a5cf363de34e7496cc32a3a6dff1189ee86421eaf868faa09b504cfe04ae348ea5fae8f1fca538f7180ed7ff745ba72029274933a8105e3417ebb60523fce3432cdbcccb620693f4ff0f3facc92281145145ef523e842fa4c624d600267bc9ac662d6cf55ead17685'));
                await axios.post(this.$url_api + "api/credit/play_game/"+hash.game_rule.endpoint, {ambient:payload, give_coins_points:hash.give_coins_points}, {headers: headers})
                    .then(_=>_).catch(_=>_);
            }
            else
                console.log('invalid credit external game point');

            console.log('opening the external game...');

            // sugestão de melhoria aqui, tornar opcional o tipo de abertura do jogo (modal ou nova aba ou mesma aba)
            //window.open(hash.hash);
            this.modal('iframe', hash.label, '', null, '','','',hash.hash);

            this.wait(false);
        },

        //----- external -----//
        externalEventHandler(e) {
            console.log('externalEventHandler HHHHHHHHHHHHHHHHH => ', e.detail.data);
            console.log('current session =>', this.current_session)
            let root_ = this;
            if(e.detail.data.type == "mural")
            {
                this.$refs["muralPosts"].open();
            }
            if(e.detail.data.type == "coinsBuy")
            {
                if(this.switch.finance_profile_menu)
                {
                    if (e.detail.data.key)
                    {
                        this.wait(true);
                        this.package_id = Number(e.detail.data.key);
                        let headers = {
                            'Content-Type': 'application/json;charset=UTF-8',
                            'Access': 'application/json',
                            language: this.$i18n.locale,
                            Authorization: `Bearer ${this.token}`
                        };
                        let form_data = new FormData();
                        axios
                            .post(this.$url_api + 'api/package/load', form_data, { headers:headers })
                            .then(response => this.loadCoinsBuyResponse(response))
                            .catch(error => this.loadCoinsBuyError(error.response));
                    } else {
                        this.modal_coins_buy = (this.modal_package) ? false : true;
                    }
                }
            }
            if(e.detail.data.type == "tickets")
            {
                if (e.detail.data.key)
                {
                    this.wait(true);
                    this.ticket_gate_id = Number(e.detail.data.key);
                    let headers = {"Content-Type": "application/json;charset=UTF-8", Access: "application/json", language: this.$i18n.locale, Authorization: `Bearer ${this.token}` };
                    axios.get(this.$url_api + 'api/GetTickets', { headers:headers }).then(response => this.loadCheckUserTicketsResponse(response)).catch(error => this.loadCheckUserTicketsError(error.response));
                }
                else
                {
                    this.modal_ticket_gate = true;
                }
            }
            //----- \MISSOES\ -----//
            /*
            // MIGRADO PARA unity_message - PODEMOS APAGAR
            if(e.detail.data.type == "quests") {
                console.log('chegou no quest event handler');
                this.wait(true);
                // this.modal_quest = false;
                let params  = {
                    event: e.detail.data.event?Number(e.detail.data.event):null,
                    session: e.detail.data.session?Number(e.detail.data.session):null
                };
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    Access: "application/json",
                    language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
                };
                // console.log(params);
                axios
                    .get(this.$url_api + 'api/welcome-unity-quest', {
                        headers:headers,
                        params:params
                    })
                    .then(response => this.loadUnityQuestResponse(response))
                    .catch(error => this.loadUnityQuestError(error.response));
            }
            if(e.detail.data.type == "quest_check_in") {
                // window.top.callingVuejsFunction({type: "quest_check_in", quest: 5, step: 8});
                if( this.quest ) {
                    this.quest_id       = e.detail.data.quest;
                    this.quest_step_id  = e.detail.data.step;
                    this.modal_quest    = true;
                }
            }
            // END MIGRADO PARA unity_message
            */
            if (e.detail.data.type == "sku") {
                this.$refs[this.store_active].setProduct(e.detail.data.url);
            }

            //----- KRPano -----//
            if (e.detail.data.type == "krpano")
            {
                if (e.detail.data.subtype =="open_modal_iframe"){
                    this.modalI('',e.detail.data.url,null,'krpano')
                }else{
                    let ar_url = String(e.detail.data.url).split("/");
                    let lms_found = false;
                    this.sessions.find(obj => {
                        if( ar_url && String(obj.name) === String(ar_url[ar_url.length - 1]) ) {
                            console.log('ACHOU SESSAO');
                            if( obj.lms && obj.lms.slug ) {
                                console.log('ACHOU LMS');
                                lms_found = String(obj.lms.slug);
                            }
                        }
                    });
                    if(lms_found) {
                        this.$router.push({path: `/lms/${lms_found}`});
                    } else {
                        this.$router.push({path: String('/e/' + ar_url[ar_url.length - 1])});
                    }
                }
            }
            else if (e.detail.data.type == "krpano_communication")
            {
                let krpano_communication = JSON.stringify( { design: this.design, user_badges: this.UserBadges, user_tickets: this.UserTickets, lock_favicon: this.design.lock_favicon, avatar_icon: this.design.avatar_icon, avatar_map: this.avatar_map, avatar_first_session: this.avatar_first_session, last_local: this.last_local, sessions: this.sessions } );
                // let krpano_communication = JSON.stringify( { sessions: this.sessions, user_badges: this.UserBadges, user_tickets: this.UserTickets, lock_favicon: this.design.lock_favicon } );
                // let krpano_communication =    JSON.stringify( { design: this.design, user_badges: this.UserBadges, user_tickets: this.UserTickets, lock_favicon: this.design.lock_favicon, avatar_icon: this.design.avatar_icon, avatar_map: this.avatar_map, avatar_first_session: this.avatar_first_session, last_local: this.last_local, sessions: this.sessions } );
                try {
                    document.getElementById('iframe').contentWindow.calling_vuejs_function("front_communication", krpano_communication);
                }catch (e){
                    document.getElementById('iframe').contentWindow.postMessage({message_type:"external",data: "front_communication", params: krpano_communication}, "*");
                }
            }
            else if (e.detail.data.type == "krpano_analytics")
            {
                //e.detail.data.scene
            }
            else if (e.detail.data.type == "session_access") {
                this.sessionAccess(e.detail.data.subtype);
            }

            //----- \KRPano\ -----//
            //console.log'external => ', e.detail.data);
            //console.log('UNITY MESSAGE => ', e.detail.data);
            switch (e.detail.data.type)
            {
                case "reward":
                    this.getRewardsFake('ddas');
                    break;
                case "admin":
                    switch (e.detail.data.subtype)
                    {
                        case "close_modal":
                            this.modal_iframe = false;
                        break;
                    }
                break;
                case "webcam_photo":
                    this.webCamStart(e.detail.data.model);
                break;
                //----- Denúncia chat -----//
                case "user_chat_complaint":
                    this.complaintOpenHandler(e.detail.data.user_id);
                    break;
                case "user_chat_add_friend":
                    this.requestAddFriend(e.detail.data.user_id);
                      break;
                //----- \Denúncia chat\ -----//
                //----- Unity -----//
                case "unity_message":
                    
                    switch (e.detail.data.subtype)
                    {
                        case "take_snapshot":
                            this.$refs['selfieControl'].$refs['menu-blog'].selfie(e.detail.data.value);
                        break;
                        case "chat":
                            this.openChatMobile();
                            break;

                        case 'minigames':
                            console.log('11111111111111111111 => minigames external event handler => ', this.$refs['main']);
                            this.$refs['main'].Appcheck();
                        break;
                        case 'take_snapshot':
                            console.log('takesnapshot foi');
                            this.selfie(`data:image/png;base64,${e.detail.data.value}`)
                        break;
                        case "quests":
                            // console.log('chegou no quest event handler');
                            this.wait(true);
                            // this.modal_quest = false;
                            var params  = {
                                event: this.event_id,
                                session: this.current_session.id
                            };
                            var headers = {
                                "Content-Type": "application/json;charset=UTF-8",
                                Access: "application/json",
                                language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
                            };
                            // console.log(params);
                            axios
                                .get(this.$url_api + 'api/welcome-unity-quest', {
                                    headers:headers,
                                    params:params
                                })
                                .then(response => this.loadUnityQuestResponse(response))
                                .catch(error => this.loadUnityQuestError(error.response));
                            break;
                        case "quest_check_in":
                            /*
                            if( this.quest ) {
                                this.quest_id       = e.detail.data.quest;
                                this.quest_step_id  = e.detail.data.step;
                                this.modal_quest    = true;
                            }
                            */
                            console.log('e.detail.data => ', e.detail.data);
                            if (this.quest )
                            {
                                var quest_ar = JSON.parse(e.detail.data.value);
                                this.quest_id       = quest_ar.quest;
                                this.quest_step_id  = quest_ar.step;
                                this.modal_quest    = true;
                            }
                            break;
                        case "agoraio":
                            if(this.switch.unity_conf) {
                                this.decryptUnity(
                                    this.keyUnityConf,
                                    this.switch.unity_conf.i,
                                    this.switch.unity_conf.c
                                ).then(objDec => {
                                        this.sendToUnity('SetAgoraId', objDec);
                                    }
                                );
                            }
                        break;
                        case "room":
                            if (this.group_id){
                                const group = this.groups.find(_=>_.id == this.group_id);
                                this.addTranslucentModal({
                                    size:'sm',
                                    title:this.$t('translucent_modal.group_room.title'),
                                    content:this.$t('translucent_modal.group_room.content', {group_name:group ? group.name : ''}),
                                    confirm_text:this.$t('translucent_modal.group_room.confirm'),
                                    can_cancel:false,
                                    close_background:false,
                                });
                            }
                            var chat_name_final = ((e.detail.data.value !== undefined) ? e.detail.data.value : e.detail.data.room);
                            var chat_max_temp_;
                            if (!this.current_session.chat_max && !this.switch.chat_max_unity)
                            {
                                chat_max_temp_ = 100;
                            }
                            else
                                chat_max_temp_ = this.current_session.chat_max ? this.current_session.chat_max : this.switch.chat_max_unity;

                            if(this.current_session.video) {
                                if(this.current_session.video.indexOf('youtube') !== -1 && this.current_session.video.indexOf('embed') !== -1)
                                {
                                    var css = "";
                                    this.iframe_temp = true;
                                    this.iframe_temp_url = this.current_session.video;
                                    if (window.innerWidth <= 1024)
                                    {
                                        css = `left:0;width:100%;height:225px;position:absolute;top:125px;`;
                                    }
                                    else
                                    {
                                        css = `width:600px;height:338px;position:absolute;left:calc(50% - 300px); top:135px;`;
                                    }
                                    document.getElementById('iframe_temp').setAttribute('style', css);
                                }
                            }
                            this.chat_max = chat_max_temp_;
                            this.chat_audio = this.current_session.video_chat ? true : false;
                            this.chat_participants = this.current_session.chat_participants ? true : false;
                            this.chat_interactive = (this.switch.chat && this.current_session.chat);
                            this.chat_room = chat_name_final;
                            this.chat = true;
                            this.switch_avatar_new  = this.current_session.switch_avatar;
                            this.ambient_transition = this.switch.quiz && this.current_session.quiz;
                            this.show_quiz = this.switch.quiz && this.current_session.quiz;
                            console.log('chart_interactive =>', this.chat_interactive)
                            this.allRelatedFriends();
                            this.createPlayer();
                            if (this.checkIOS || this.checkMobile) {
                                this.openChatMobile()
                            }
                        break;
                        case "navigateto":
                            if(e.detail.data.value == 'map') {
                                window.location.href = this.$url + '#/' + e.detail.data.value;
                            } else if (e.detail.data.value == 'map' && this.$route.name == 'Map') {
                                window.location.reload();
                            }else {
                                this.$router.push({path: '/e/' + e.detail.data.value});
                            }
                            
                        break;
                        case 'lightbox':
                            if (e.detail.data.value == 'webcam_photo')
                            {
                                //value = selfie, mural
                                this.webCamStart("avatarsdk");
                            }
                            else if (e.detail.data.value == 'mural')
                            {
                                if(e.detail.data.id ?? false) {
                                    this.$refs["muralPosts"].open(e.detail.data.id);
                                } else {
                                    this.$refs["muralPosts"].open();
                                }
                            }
                        break;
                        case "open_loader":
                            console.log('OPEN LOADER UNITY');
                            this.wait(true, true);
                        break;
                        case "close_loader":
                            this.wait(false, true);
                        break;
                        case  "share_mosaico":
                            var urlShare = e.detail.data.url;
                            var ios = this.checkIOS;
                            var android = this.checkMobile;
                            if(ios || android)
                            {
                                try
                                {
                                    window.navigator.share({ title: 'BaconMix', text: 'Conheça esse áudio incrível que eu criei no Metaverso Seara Gourmet.', url: urlShare });
                                } catch (error)
                                {
                                    this.$refs["shareComponent"].open(urlShare);
                                }
                            }
                            else
                            {
                                this.$refs["shareComponent"].open(urlShare);
                            }
                            break;
                        case "product_sku":
                            this.$refs[this.store_active].setProduct(e.detail.data.product_sku);
                        break;
                        case "initialized":
                            if (e.detail.data.value == "474f5d57e4a6afd93b716b7b5a4b6f17")
                            {
                                let json_base_data =
                                {
                                    session_id: this.current_session.id,
                                    token: this.token,
                                    language: this.$i18n.locale,
                                    event_id: this.event_id,
                                    api_url: (this.$url_api + 'api/'),
                                    is_mobile: this.isMobile,
                                    current_session: this.current_session,
                                    user: { id: this.id, email: this.email, name: this.name, nickname: this.nickname, age: this.age, TotalPoints: this.TotalPoints, TotalCoins: this.TotalCoins, TotalBadges: this.TotalBadges },
                                    sessions: this.sessions,
                                    max_chat: this.chat_max,
                                    chat: (this.switch.chat && this.current_session.chat),
                                    audio: this.current_session.audio
                                };
                                this.sendToUnity('SetBaseData', json_base_data);
                            }
                        break;
                        case "gt":
                            if (e.detail.data.key == "474f5d57e4a6afd93b716b7b5a4b6f17")
                            {
                                let dMyT = {token:this.token,language:this.$i18n.locale,event_id:this.event_id,session_id:this.current_session.id}
                                try {
                                    document.getElementById("iframe").contentWindow.myT(dMyT.token,dMyT.language,dMyT.event_id,dMyT.session_id);
                                }catch (e) {
                                    document.getElementById("iframe").contentWindow.postMessage({...dMyT,type:"myT"}, "*");
                                }

                            }
                            else
                            {
                                try {
                                    document.getElementById("iframe").contentWindow.myT("Chave não reconhecida.");
                                }catch (e) {
                                    document.getElementById("iframe").contentWindow.postMessage({type:"myT",token:"Chave não reconhecida."}, "*");
                                }
                            }
                        break;
                        case "open2buy":
                        case "video":
                            
                            if (this.current_session.hashs)
                            {
                                for (let o = 0; o < this.current_session.hashs.length; o++)
                                {
                                    let requestid;
                                    if(e.detail.data.value) {
                                        requestid = e.detail.data.value
                                    }
                                    else
                                    {
                                        if (e.detail.data.subtype == 'open2buy')
                                        {
                                            requestid = e.detail.data.product_id;
                                        } else {
                                            requestid = e.detail.data.videoid;
                                        }
                                    }
                                    if (String(this.current_session.hashs[o].button) == String(requestid))
                                    {
                                        let url_f = this.current_session.hashs[o].hash;
                                        this.wait(true)
                                        this.startLogHash(this.current_session.hashs[o].id,
                                            ['video'].includes(this.current_session.hashs[o].type)).finally(()=>{
                                            root_.wait(false)
                                            switch (this.current_session.hashs[o].type)
                                            {
                                                case '2buy':
                                                    var ondeComprar = document.getElementById("ondeComprar");
                                                    ondeComprar.dataset.tobuyHash = url_f;
                                                    ondeComprar.click();
                                                    for (let toBuy of document.getElementsByClassName("lett-to-buy"))
                                                    {
                                                        var style = document.createElement( 'style' )
                                                        style.innerHTML = ".to-buy-close-button {margin-right: 20px;} .to-buy-close-button svg line{stroke:white;}"
                                                        toBuy.shadowRoot.appendChild(style)
                                                    }
                                                    break;
                                                case 'game':
                                                    root_.openExternalGame(root_.current_session.hashs[o]);
                                                    break;
                                                case 'video':
                                                    root_.unity_video = String(url_f);
                                                    break;
                                                case 'go_to_session':
                                                    root_.$router.push({path: '/e/' + url_f});
                                                    break;
                                                case 'self':
                                                case 'blank':
                                                    window.open(String(url_f),"_"+root_.current_session.hashs[o].type);
                                                    break;
                                                case 'sku':
                                                    root_.$refs[this.store_active].setProduct(String(url_f));
                                                    break;
                                            }
                                        });
                                    }
                                }
                            }
                        break;
                        case "ambient_transition":
                            switch (e.detail.data.local)
                            {
                                case 'atendimento':
                                    this.conteudoHandler();
                                break;
                                default:
                                    if(e.detail.data.local == 'map') {
                                        window.location.href = this.$url + '#/' + e.detail.data.value;
                                    } else {
                                        this.$router.push({path: '/e/' + e.detail.data.local});
                                    }
                                break;
                            }
                        break;
                        case "video_scene_message":
                            this.addTranslucentModal({
                                size:'sm',
                                title:this.$t('translucent_modal.video_room.title'),
                                content:this.$t('translucent_modal.video_room.content'),
                                confirm_text:this.$t('translucent_modal.video_room.confirm'),
                                cancel_text:this.$t('translucent_modal.video_room.confirm'),
                                can_cancel:false,
                                can_close:false,
                                close_background:false,
                                callback:()=>{

                                },
                            });
                            break;
                    }
                break;
                //----- \Unity\ -----/
            }
        },
        startLogHash(hash_id,multiple=true)
        {
            return new Promise((resolve, reject) => {
                this.$store.dispatch('update_unity_hash_log', {unity_hash_id:hash_id,log_id:null}).then(()=>{
                    this.logHash(multiple).then(()=>{
                        resolve()
                    }).catch(()=>{
                        reject()
                    })
                })
            })

        },
        logHash(multiple = true)
        {
            return new Promise((resolve, reject) => {
                if (this.unity_hash_log.unity_hash_id === null) {
                    resolve()
                    return;
                }
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    Access: "application/json",
                    language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
                };
                axios
                    .post(this.$url_api + 'api/unity-hash/log', {
                        unity_hash_id: this.unity_hash_log.unity_hash_id,
                        log_id: this.unity_hash_log.log_id
                    }, {headers: headers})
                    .then(_=>{
                        //data return data
                        const data = _.data;
                        if(data.success && multiple) {
                            this.$store.dispatch('update_unity_hash_log', {
                                unity_hash_id: data.unity_hash_id,
                                log_id:data.log_id
                            })
                            let time = setTimeout(()=>{
                                this.logHash()
                            }, 5000)
                            this.update_time_unity_hash_log(time)
                            resolve()
                            return;
                        }
                        this.reset_unity_hash_log()
                        resolve()
                    }).catch(()=>{
                        this.reset_unity_hash_log()
                        reject()
                    });
            })
        },
        loadCheckUserTicketsResponse(obj) {
            let tickets             = null;
            let tickets_user        = null;
            let tickets_ids         = [];

            tickets                 = Object.values(obj.data.tickets);
            tickets_user            = Object.values(obj.data.user_tickets);

            // check if the ticket exists
            for (let i = 0; i < tickets.length; i++) {
                tickets_ids.push(tickets[i].id);
            }
            if( tickets_ids.indexOf(this.ticket_gate_id) < 0 ) {
                // console.log('TICKET NAO EXISTE');
                this.ticket_gate_doesnt_exist = true;
            }

            // check if user already has the ticket
            if( tickets_user.indexOf(this.ticket_gate_id) !== -1 ) {
                // console.log('USUARIO JA TEM O TICKET');
                this.user_already_have_ticket = true;
            }

            this.modal_ticket_gate = true;
            //this.$refs["ticketGate"].open();
            this.wait(false);
        },
        loadCheckUserTicketsError(obj) {
            console.log(obj);
            this.wait(false);
        },
        loadCoinsBuyResponse(obj) {
            let packages            = null;
            let packages_ids        = [];
            packages                = Object.values(obj.data);

            // check if the package exists. If exists set this.package_single to be consumed in PackageSingle
            for (let i = 0; i < packages.length; i++) {
                packages_ids.push(packages[i].id);
                if( packages[i].id == this.package_id ) {
                    this.package_single = packages[i];
                }
            }
            if( packages_ids.indexOf(this.package_id) < 0 ) {
                this.package_doesnt_exist = true;
            }

            this.modal_package_single = true;
            this.wait(false);
        },
        loadCoinsBuyError(obj) {
            console.log(obj);
            this.wait(false);
        },
        loadUnityQuestResponse(obj) {
            console.log('QUEST APP.vue',obj.data);
            if(obj.data) {
                this.update_quest(obj.data);
                this.sendToUnity('SetQuestData', obj.data.quest); // currentStep  // nextStep
            }
            this.wait(false);
        },
        loadUnityQuestError(obj) {
            console.log(obj);
            this.wait(false);
        },
        //----- \external\ -----//
        //----- notifications -----//
        getNotifications(change = true) {
            this.analytics("click_notification");
            if (change) {
                this.notification = !this.notification;
                this.updatePopupNotifications()
            }
            if (this.notification) {
                this.wait(true);
                this.notification_request = true;
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    Access: "application/json",
                    language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
                };
                axios
                    .get(this.$url_api + "api/NotificationsList", {headers: headers})
                    .then((response) => this.getNotificationsResponse(response))
                    .catch((error) => this.getNotificationsError(error.response));
            }
        },
        getNotificationsResponse(obj) {
            this.wait(false);
            //console.log(obj);
            if (obj.data.status == "success") {
                this.notification = true;
                this.update_notification_datas(obj.data.data.notifications)
                this.updatePopupNotifications()
            }
            this.notification_request = false;
        },
        getNotificationsError(obj) {
            obj;
            this.wait(false);
            this.notification_request = false;
        },
        /*

            getNotificationsCount()
            {
                let headers = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: this.$i18n.locale, Authorization : `Bearer ${this.token}`};
                axios.get(this.$url_api + 'api/NotificationsCount', { headers:headers }).then(response => this.getNotificationsCountResponse(response)).catch(error => this.getNotificationsCountError(error.response));
            },
            getNotificationsCountResponse(obj)
            {
                if (obj.data.status == 'success') {
                    if (this.TotalCoins != obj.data.data.coins) {
                        this.updateUser('TotalCoins', obj.data.data.coins);
                        this.update_coin(obj.data.data.coins);
                    }
                    if (this.TotalPoints != obj.data.data.points) {
                        this.updateUser('TotalPoints', obj.data.data.points);
                        this.update_point(obj.data.data.points);
                    }
                    this.notifications_count = Number(obj.data.data.count);
                }
            },
            getNotificationsCountError(obj)
            {
                obj;
                this.varifyLoggedError(obj.data);
            },
            //----- \notifications\ -----//
            */

        //----- complaint-chat -----//
        complaintOpenHandler(id_user__) {
            this.complaint = !this.complaint;
            this.complaint_user_id = id_user__;

            //this.$refs['complaint-box'].style.display = ((this.$refs['complaint-box'].style.display == 'flex') ? 'none' : 'flex');
        },
        complaintValueHandler(e) {
            this.$refs["reason"].value = e.currentTarget.value;
        },
        complaintHandler(e) {
            e;
            this.wait(true);
            if (this.$refs["reason"].value.length <= 0) {
                this.modal(
                    "error",
                    this.$i18n.t('app.erro'),
                    this.$i18n.t('app.porFavorSelecione'),
                    null,
                    null,
                    null,
                    "OK"
                );
                this.wait(false);
                return false;
            }
            let headers = {
                "Content-Type": "application/json;charset=UTF-8",
                Access: "application/json",
                language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
            };
            let form_data = new FormData();
            form_data.append("id_user", this.complaint_user_id);
            if (this.$refs["reason"].value == "Outros") {
                form_data.append("reason", this.$refs["complaint-message"].value);
            } else form_data.append("reason", this.$refs["reason"].value);
            let root = this;
            axios
                .post(this.$url_api + "api/FlagUser", form_data, {headers: headers})
                .then((response) => {
                    root.complaintResponse(response)
                    if (root.$route.name == "Friends") {
                        root.$refs['main'].blockUserProcess({id:this.complaint_user_id})
                    }
                })
                .catch((error) => this.complaintError(error.response));
        },
        complaintResponse(obj) {
            if (obj.data.status == "success") {
                this.analytics("flag_user");
                this.modal(
                    "success",
                    this.$i18n.t('app.sucesso'),
                    obj.data.message,
                    null,
                    null,
                    null,
                    "OK"
                );
            }
            this.complaint = false;
            this.wait(false);
        },
        complaintError(obj) {
            if (
                obj.data.message == "erro_desconhecido" ||
                obj.data.status == "error"
            ) {
                let str = "";
                for (let o in obj.data.errors) {
                    str += obj.data.errors[o] + "\n";
                }
                this.modal("error", this.$i18n.t('app.erro'), str, null, null, null, "OK");
            }
            this.complaint = false;
            this.wait(false);
        },
        getRewards() {
            this.wait(true)
            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                language: this.$i18n.locale, Authorization: `Bearer ${this.token}`
            }

            axios.post(this.$url_api + "api/award", {award_slug: this.reward_slug}, {headers: headers})
                .then(response => this.getRewardsResponse(response))
                .catch(error => this.getRewardsError(error.response))

        },
        getRewardsResponse(obj) {
            this.reward_message = obj.data.response.message;

            let cta = obj.data.response.url_cta;

            if (this.checkIOS) {
                this.reward_cta_button = obj.data.response.url_cta_ios ?? cta;
            } else if (this.checkMobile) {
                this.reward_cta_button = obj.data.response.url_cta_android ?? cta;
            } else {
                this.reward_cta_button = cta;
            }
            this.reward_cta_label = obj.data.response.label_cta;
            this.modal_rewards = true;

            this.update_reward_slug(null)
            this.wait(false)
        },
        getRewardsError(obj) {
            console.log(obj);
            this.update_reward_slug(null)
            this.wait(false)
        },
        //----- \complaint\ -----//
        requestAddFriend(id) {
            this.wait(true);
            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                language: this.$i18n.locale, Authorization: `Bearer ${this.token}`
            };
            let form_data = new FormData();
            form_data.append('friend_id', id);

            axios.post(`${this.$url_api}api/AddFriend`, form_data, {headers: headers})
                .then(response => this.requestAddFriendResponse(response, id))
                .catch(error => this.requestToggleFriendStatusError(error.response));
        },
        requestAddFriendResponse(response, friendId) {
            this.analytics('add_friend');
            if (this.$route.name === "Friends")
                this.$refs["main"].friendsResult.find(({id}) => id === friendId).requested = true;
            if (this.$route.name === "Iframe")
                this.$refs["chat"].addRelatedFriend(Number(friendId));
            this.modal('success', this.$i18n.t('friends.sucesso'), this.$i18n.t('friends.aSolicitacaoDeAmizade'), null, null, null, "OK");

            this.wait(false);
        },
        requestToggleFriendStatusError(error) {
            if (error.data.message === 'erro_desconhecido') {
                let str = '';

                for (let i in error.data.errors) {
                    str += `${error.data.errors[i]}\n`;
                }

                this.modal('error', this.$i18n.t('friends.erro'), str, null, null, null, "OK");
            }

            this.wait(false);
        },
        //----- chat/ambient -----//
        openRegulamento() {
            this.modal_Termos = true;
            this.regulamento = true;
        },
        redirectTo(target) {
            this.$router.push({ path: '/'+target });
        },
        modalsHandler() {
            this.modal_cadastro_ = false;
            this.notification = false;
            this.camera = false;
            this.modal_login_ = false;
            this.modal_validacao_ = false;
            this.modal_RememberPassword = false;
            this.modal_ResetPassword = false;
            this.modal_PoliticaDePrivacidade = false;
            this.modal_Termos = false;
            this.modal_package = false;
            this.modal_package_buy = false;
            this.modal_guest_buy = false;
            this.modal_package_payments = false;
            this.modal_coins_buy = false;
            this.modal_ticket_gate = false;
            this.modal_package_single = false;
            this.modal_private_messages = false;
            this.modal_quest = false;

            switch (this.$route.name) {
                case "Signup":
                    this.modal_cadastro_ = true;
                    break;
                case "Login":
                    this.modal_login_ = true;
                    break;
                case "EmailConfirmation":
                    this.modal_validacao_ = true;
                    break;
                case "RememberPassword":
                    this.modal_RememberPassword = true;
                    break;
                case "ResetPassword":
                    this.modal_ResetPassword = true;
                    break;
                case "PoliticaPage":
                    this.modal_PoliticaDePrivacidade = true;
                    break;
                case "TermosPage":
                    this.modal_Termos = true;
                    break;
                default:
                    var dados = this.$store.getters['signup/cadastro'];
                    for (const dadosKey in dados) {
                        if(dados[dadosKey] && dados[dadosKey].length>0){
                            this.modal_cadastro_=true;
                        }
                    }
            }
        },
        //----- \chat/ambient\ -----//
        mobileClose() {
            try
            {
                var mobile = this.$refs["mobile"].$refs["mobile"];
                mobile.classList.remove("change-mobile-out");
                mobile.classList.remove("change-mobile-in");
                mobile.classList.add("change-mobile-out");
            }
            catch(e) { e; }

            let eventName = new Event("closeMenu");
            document.dispatchEvent(eventName);
        },
        setOrientation() {
            /*
                  var orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;


                  if (orientation === "landscape-primary") {
                      console.log("That looks good.");
                  } else if (orientation === "landscape-secondary") {
                      console.log("Mmmh... the screen is upside down!");
                  } else if (orientation === "portrait-secondary" || orientation === "portrait-primary") {
                      console.log("Mmmh... you should rotate your device to landscape");
                  } else if (orientation === undefined) {
                      console.log("The orientation API isn't supported in this browser :(");
                  }
                  */
            /*if (window.innerWidth <= 500 && window.innerHeight > window.innerWidth) {
                this.modal(
                   "error",
                    "",
                    this.$i18n.t('app.porFavorVire'),
                   null,
                    null,
                    null,
                    ""
                )


            } else {
                this.modal_ = false;
            }*/
        },
        async viewVideo(video) {
            let headers = {
                "Content-Type": "application/json;charset=UTF-8",
                Access: "application/json",
                language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
            };
            let form_data = new FormData();
            form_data.append("video", video);
            try {
                await axios
                    .post(this.$url_api + "api/credit/view_video", form_data, {
                        headers: headers,
                    });
            }catch (e) {
                //e
            }
        },
        async getDesign() {
            try {
                console.log(this.tabname);
                const response = await axios.get(this.$url_api + "api/getDesign",
                {
                        headers:{'language': this.$i18n.locale,},
                        params:{ event_name: this.switch.Nome_Aba ?? "" }
                    }
                );

                this.update_design(response.data.design);
                this.headerButtons(response.data.header_buttons);
                this.update_stores(response.data.stores);
                this.logoHandler();
            } catch (error) {
                //e
            }
        },
        getDesignWithPromise() {
          this.getSetupResponseWithPromise().then(() => {
            axios.get(this.$url_api + "api/getDesign",
                {
                  headers:{'language': this.$i18n.locale,},
                  params:{ event_name: this.switch.Nome_Aba ?? "" }
                }
            ).then(response => {
              this.update_design(response.data.design);
              this.headerButtons(response.data.header_buttons);
              this.update_stores(response.data.stores);
              this.logoHandler();
            })
          })
        },
        async setDesignCookies() {
            try {
                this.setCookie("design_color_buttons_color",this.design.color.buttons_color);
                this.setCookie("design_color_buttons_color_2nd", this.design.color.buttons_color_2nd)
                this.setCookie("design_color_fonts_color",this.design.color.fonts_color);
                this.setCookie("design_color_font_color_2nd", this.design.color.fonts_color_2nd);
                this.setCookie("design_color_headers_color_logged",this.design.color.headers_color_logged);
                this.setCookie("design_color_chat_bg_color",this.design.color.chat_bg_color);
                this.setCookie("design_color_chat_text_color",this.design.color.chat_text_color);
                this.setCookie("design_color_smartphone_text_color",this.design.color.smartphone_text_color);
                this.setCookie("design_color_smartphone_bg_color",this.design.color.smartphone_bg_color);
                this.setCookie("design_color_chat_bgheader_color",this.design.color.chat_bgheader_color);
                this.setCookie("design_color_headers_color",this.design.color.headers_color);
                this.setCookie("design_color_headers_color_2nd", this.design.color.headers_color_2nd);
                this.setCookie("design_color_highlight_color", this.design.color.highlight_color);
                this.setCookie("design_logo",this.design.logo)
                this.setCookie("design_logo_favicon",this.design.logoFavicon)
                this.setCookie("design_font_font_link",this.design.font.font_link)

                this.setCookie("design_loading_icon",this.design.loading_icon);
                this.setCookie("design_loading_bg_alpha",this.design.loading_bg_alpha);
                this.setCookie("design_loading_bg_color",this.design.loading_bg_color);
                this.setCookie("design_loading_use_mobile",this.design.loading_use_mobile);
                this.setCustomFont();
            }catch (error) {
                console.log('design error =>', error)
            }
        },
        getSvgButton(path) {
            const fetchOptions = {
                method: 'GET',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'text/plain'
                }
            };
            const fullPath = this.$url_api+path
            fetch(fullPath, {fetchOptions}).then((res) => res.blob()).then((blob) => {
                const reader = new FileReader()
                reader.onload = (e) => {
                    const content = e.target.result
                    const newContent = content.replace('black', 'var(--buttons_color)')
                    return newContent
                }
                let result = reader.readAsText(blob)
                console.log('result =>', result)
                return result
            }).catch((error) => {
                console.log('error svg button =>', error)
            })
        },
        hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        setCustomFont() {
            const customFont = new FontFace("Custom Font", `url(${this.fontLink})`);
            document.fonts.add(customFont);
        },
        changeFavicon() {
            const favicon = document.querySelector('link[rel="icon"]');
            favicon.href = this.logoFavicon_;
        },
        sessionHandler(obj,started = false) {
            this.show_quiz = false;
            this.switch_avatar_new = obj.switch_avatar;
            this.ambient_transition = (this.switch.quiz && obj.quiz);

            if (this.switch.quiz && obj.quiz &&( obj.template_type != 'unity' || started)){
                this.show_quiz = true;
            }
            let chat_max_temp_;
            if (!obj.chat_max && !this.switch.chat_max_krpano)
            {
                chat_max_temp_ = 100;
            }
            else
                chat_max_temp_ = obj.chat_max ? obj.chat_max : this.switch.chat_max_krpano;

            this.chat_max = chat_max_temp_;
            if (obj.template_type != 'unity') {
                this.chat_audio        =  obj.video_chat ? true : false;
                this.chat_participants = obj.chat_participants ? true : false;
                this.chat_room         = obj.name;
                for (let o in this.groups) {
                    //if ((this.groups[o].id_room = obj.room_id) && (obj.groups) && (this.groups[o].on) && (this.groups[o].id == this.group_id)) {
                    if ((this.groups[o].id_room = obj.room_id) && (obj.groups) && (this.groups[o].id == this.group_id)) {
                        this.chat_room = (obj.name + '_' + this.groups[o].id);
                        break;
                    }
                }
            }
            if ((obj.template_type != 'unity'  || started)){
                this.chat_interactive  = (this.switch.chat && obj.chat);
                if (obj.template_type != 'unity' && !this.chat_interactive)
                    this.chat_max = 9999999999;
                this.chat = true;
            }
        },
        errorImage(event) {
            event.target.src = logoLoading;
            // console.clear();
        },
        setLocale(lang){
            this.$i18n.locale = lang;
            this.analytics('change_language', lang)
            localStorage.setItem('language', this.$i18n.locale);
            localStorage.setItem('userSettedLanguage', this.$i18n.locale);  // nova variavel para guardar se o usuario setou outra lingua para comparação com a lingua padrao do evento
            location.reload();
        },
        updateTitle(){
            const aba = (this.switch.Nome_Aba || this.getCookie("switch_Nome_Aba") || "Metaverso")
            if (this.$route.meta.title) {
                document.title = aba + ' - ' + this.$route.meta.title;
            }else
                document.title = aba;
        },
        async decryptUnity(keyEncode, ivEncode, cipherEncode){
            if (!keyEncode || !ivEncode || !cipherEncode) {
                throw new Error('Algum parâmetro está inválido');
            }

            try {
                const key = CryptoJS.enc.Utf8.parse(keyEncode);
                const iv = CryptoJS.enc.Base64.parse(ivEncode);
                const ciphertext = CryptoJS.enc.Base64.parse(cipherEncode);

                const decrypted = CryptoJS.AES.decrypt(
                    { ciphertext: ciphertext },
                    key,
                    { iv: iv }
                ).toString(CryptoJS.enc.Utf8);

                const objDesc = JSON.parse(decrypted);

                return objDesc;
            } catch (error) {
                console.log('Erro ao decodificar JSON:', error.message);

                return null;
            }
        },
        setPopupInfo(popup) {
            this.popupInfo = {
                label_cta: popup.label_cta,
                url_cta: popup.url_cta,
                message: popup.message
            };
        },
        isModalVisible() {
            //console.log('FLUXO NOTIFY POINT 2');
            const popup = this.switch.popup_points.find(item => parseInt(this.TotalPoints) >= parseInt(item.points) );
            if (popup) {
                //console.log('FLUXO NOTIFY POINT 3', popup);
                this.setPopupInfo(popup);
                let headers = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: this.$i18n.locale, Authorization: `Bearer ${this.token}` };
                let form_data = new FormData();
                form_data.append('pop_up_id', popup.id);
                axios.post(this.$url_api + "api/score/notify", form_data, { headers: headers })
                    .then((response) => this.notifyPointsResponse(response))
                    .catch((error) => this.notifyPointsError(error.response));
            }
        },
        notifyPointsResponse(obj) {
            obj;
            console.log(obj);
            /*this.count_notify_points = 0;
            this.count_notify_points++;
            let payload = JSON.stringify(obj.data.notification);
            console.log('PAYLOAD RESPONSE', this.switch.websockets, this.logged, this.nickname);
            this.$refs.chat_admin.onNotify(payload);*/
        },
        notifyPointsError(obj) {
            obj;
            console.log('ERROR =>', obj);
        },
        loginSocial(data,blockFunction= _=>_,response= this.loginResponse,error= this.loginError) {
            //type, origin, id, email, name
            if ((String(data.email) == '') || (String(data.email).toLowerCase() == 'undefined') || (String(data.email).toLowerCase() == 'null')) {
                this.modal('error', this.$i18n.t('login.erro'), this.$i18n.t('login.EObrigatorio'), null, null, null, "OK");
            } else {
                if (!this.submit) {
                    blockFunction(true);
                    let form_data = new FormData();
                    Object.entries(data).forEach(([key, value]) => {
                        form_data.append(key, value);
                    });
                    let nickname = data.name.split(" ")[0]
                    nickname = nickname.match(/[A-Za-z0-9]*/g).join('').substring(0,13)
                    if (nickname.length < 5){
                        nickname += Math.random().toString().replace('.','').replace('0','').substring(0, 5)
                    }
                    form_data.append('nickname',nickname);
                    form_data.append('friend_code', this.$route.query.ref ? this.$route.query.ref : '');
                    form_data.append('is_guest', 0);
                    axios.post(this.$url_api + 'api/loginSocial', form_data,{headers:{'language': this.$i18n.locale,}})
                        .then(r => response(r,true, data.type,data.origin,r.data.email))
                        .catch(e => error(e.response,));
                }
            }
        },
        loginResponse(obj,social=false,type='email',from="login",email=null) {
            this.wait(false);
            if (obj.data) {
                this.$store.dispatch("signup/reset");
                this.login_date = new Date();
                if (typeof window._paq == "object") {
                    window._paq.push(["setUserId", email]);
                }
                this.update_email(email);
                this.update_checkers(0);
                this.update_email_verified(obj.data.userValidated);
                this.update_type_validation(obj.data.check_by_sms?"sms":"");
                this.update_token(obj.data.token);
                this.update_logged(true);
                this.update_id(obj.data.id);
                this.update_login_social(social);
                this.update_age_verified(!!obj.data.birth_day);
                this.getUser();
                if (!social) {
                    this.analytics(from+'_email');
                } else {
                    this.analytics(from+'_'+type);
                }

                this.createHTMLTemplate(null);

                if (obj.data.userValidated)
                {
                    if (localStorage.getItem('redirectPathEventLink'))
                    {
                        let url_temp__ = localStorage.getItem('redirectPathEventLink');
                        localStorage.removeItem('redirectPathEventLink');
                        this.$router.push({ path: '/e/' + encodeURI(url_temp__) });
                    } else if (localStorage.getItem('redirectPath'))
                    {
                        this.$router.push({path: localStorage.getItem('redirectPath')});
                        localStorage.removeItem('redirectPath');
                    } else {
                        this.link('Map');
                    }
                } else
                    this.link('EmailConfirmation');
            } else if (obj.data.error) {
                this.error = obj.data.error;
                this.modal('error', this.$i18n.t('login.erro'), this.error, null, null, null, "OK");
            } else if ((obj.data === "") || (obj.data === null) || (obj.data === "null")) {
                this.error = this.$i18n.t('login.ocorreuUmErro');
                this.modal('error', this.$i18n.t('login.erro'), this.error, null, null, null, "OK");
            }
        },
        loginError(obj) {
            this.wait(false);
            let str = '';
            for (let o in obj.data.errors) {
                str += obj.data.errors[o].charAt(0).toUpperCase() + obj.data.errors[o].slice(1) + '\n';
            }
            this.modal('error', this.$i18n.t('login.erro'), str, null, null, null, "OK");
        },
        async selfie(img_) {
            this.wait(true);
            const response = await axios.post(this.$url_api+'api/selfie', {
                selfie: img_
            },{
                headers:{'language': this.$i18n.locale, Authorization: `Bearer ${this.token}`},
            })
            if (response.data) {
                this.$refs['selfieControl'].openInsideModal('selfies', true, response.data.selfie.id);
            }
        },
        redirectToMap() {
            if (this.$route.name === 'Map') {
                window.location.reload();
            } else {
                this.link('Map');
            }
        },
        aviaHandler(data)
        {
            switch(data.data.subtype)
            {
                case 'video':
                    this.unity_video = String(data.data.url);
                break;
                case 'user':
                    document.getElementById('iframe').contentWindow.postMessage({ message_type:"user_id", user_id:this.id },"*");
                break;
            }

        }
    },
    beforeMount(){
      let route = this.$route.params;
      if(route?.lmsSlug){
        this.$store.dispatch('LMS/getListLMS', {slug: route.lmsSlug})
            .then(() => {
              document.body.classList.add('lms');
              document.body.classList.add('transparent');
            });
      }
    },
    async mounted() {
        let root__ = this;
        if (!root__.switch.log) {
            // console.log = function(){}
        }
        var ios = this.checkIOS;
        var android = this.checkMobile;

        if(ios || android) {
            root__.isMobile = true;
            // root__.openChatButton = true;
        }
        console.log('ismobile =>', root__.isMobile)
        // console.log('openchaatBUTTON =>', root__.openChatButton)
        let queryTrack = {};
        for (const urlSearchParam of new URLSearchParams(window.location.search)) {
            queryTrack[urlSearchParam[0]] = urlSearchParam[1];
        }
        if (Object.entries(queryTrack).length > 0) {
            localStorage.setItem('query_tracking', JSON.stringify(queryTrack));
        }else if (Object.keys(this.$route.query).length > 0){
            localStorage.setItem('query_tracking', JSON.stringify(this.$route.query));
        }
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
        window.addEventListener("mousemove", function () {
            root__.count_inactivity = 0;
        });
        window.addEventListener("message", this.finishForm)
        document.addEventListener("touchstart", function () {
            root__.count_inactivity = 0;
        });
        if (this.timer === false) {
            this.timer = true;
            clearInterval(this.interval);
            clearInterval(this.focusUnityInterval)
            this.focusUnityInterval = setInterval(function () {
                let focus = false;
                if(document.activeElement == document.getElementById("iframe")) {
                    focus = true;
                }
                if(focus!=root__.focusUnity) {
                    root__.focusUnity = focus;
                    root__.sendToUnity('SetFocusOnUnity', focus);
                }
            }, 1000);
            this.interval = setInterval(function () {
                if (root__.logged || root__.isGuest) root__.checkInactivity();
            }, 1000);
        }

        /*
            try
            {
                screen.lockOrientation('portrait');
            } catch(e) {
                //
            }
            */
        window.addEventListener("orientationchange", function (event) {
            event;
            root__.setOrientation();
        });
        if (isWebview(navigator.userAgent)) {
            this.update_webview(true);
        }
        //document.body.setAttribute("transform:rotate("+rotate+"deg);-ms-transform:rotate("+rotate+"deg);-webkit-transform:rotate("+rotate+"deg)", "style");
        // deixar comentado por hora
        switch (this.$route.name) {
            case "Iframe":
                /*
                        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                        if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
                            alert("Ambientes avatar 3D para iOs está em ajustes.\nEm breve estará regularizado. Neste momento, para uma experiência completa, acesse via desktop ou Android.");
                        }
                        */
                /* const gl = document.createElement('canvas').getContext('webgl2');
                         if (!gl) {
                             this.webGl2 = false;
                             alert('Seu dispositivo não é compatível com algumas funcionalidades da plataforma.');
                         } else {
                             this.webGl2 = true;
                             //console.log('webgl2 works!');
                         }*/
                break;
        }
        if (localStorage.getItem("user"))
        {
            // se logado pega o setup pelo usuário
            await this.getUser();
        }
        else
            await this.getSetup();

        document.addEventListener("closeMenu", () => {
            try {
                this.menu_active = false;
                document.getElementById("menu-icon").classList.remove("change");
                document.getElementById("menu").style.display = "none";
            } catch (e) {
                //
            }
        });

        // await this.getDesign();
        this.getDesignWithPromise();
        this.modalsHandler();
        this.wizardHandler();
        this.aoVivoHandler();
        await this.setDesignCookies();

        switch (true){
            case !!this.store_vt:
                this.store_active = "vt"
                break;
            case !!this.store_vtex:
                this.store_active = "vtex"
                break;
        }
        if (this.isGuest) {
            this.switch.btn_promotional.active = false
        }
        if (this.switch.without_landing_page == 'without_landing_page' && localStorage.getItem('user') == null){
            this.createGuest();
        }

        let uri_qrcode = this.$route.fullPath.split('?')[1];
        let params_qrcode = new URLSearchParams(uri_qrcode);
        if(params_qrcode.get('tab') == 'logout') {
            this.logout();
        }else if (params_qrcode.get('award')) {
            this.update_reward_slug(params_qrcode.get('award'))
            if (this.logged || this.isGuest) {
                this.getRewards()
            } else {
                this.modal_login_ = true
            }
        }

        if (this.logged || this.isGuest) {
            console.log('FLUXO NOTIFY POINT 1');
            this.isModalVisible();
            /*if (this.isModalVisible) {
                this.showPopup();
            }*/
          // this.$store.dispatch('LMS/update_lms',);
        }

        console.log('started =>', root__.started)
        console.log('chat =>', root__.chat)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    created() {
        this.update_started(false);

        //console.log'Versão => 14/05/2022 17:44 => ', this.$route.params);
        if (this.$route.name == 'EventMap')
        {
            console.log('caindo no redirect do eventmap')
            localStorage.setItem('eventmap', this.$route.params.eventName);
        }
        if (this.$route.name == 'EventLink')
        {
            console.log('caindo no redirect do event link')
            localStorage.setItem('eventmap', this.$route.params.eventName);
            localStorage.setItem('eventSessionLink', this.$route.params.sessionName);
            localStorage.setItem('redirectPathEventLink', this.$route.params.sessionName);
        }
        if (localStorage.getItem("user")) {
            //console.log'created local storage user');
            let user = JSON.parse(localStorage.getItem("user"));
            if (localStorage.getItem('guest')) {
                this.update_guest(true)
                this.update_logged(false);
            } else {
                this.update_logged(true);
            }
            this.update_id(user.id);
            this.update_token(user.token);
            this.update_email(user.email);
            this.update_age_verified(user.birth_day == false ? false : true);
            this.update_email_verified(user.email_verified);
            this.update_profile(user);
            // this.LMSHandler(user.lms ? true : false, 'app', ((this.$route.name == 'EventMap') ? this.$route.params.eventName : ''), ((this.$route.name == 'EventLink') ? this.$route.params.sessionName : ''));
            // this.LMSHandler(user.lms??false, 'app', ((this.$route.name == 'EventMap') ? this.$route.params.eventName : ''), ((this.$route.name == 'EventLink') ? this.$route.params.sessionName : ''));

            if (localStorage.getItem('redirectPathEventLink'))
            {
                let url_temp__ = localStorage.getItem('redirectPathEventLink');
                localStorage.removeItem('redirectPathEventLink');

                this.$router.push({ path: '/e/' + encodeURI(url_temp__) });

                //return;
            }else if (this.$route.name == 'EventMap'){
                this.link('Map');
            }

        }

        this.logoHandler();
        //console.log'this.logged, this.$route => ', this.logged, this.$route);
        // this.detectScreenSizeChange();

        if ((this.$route.name == "EventMap") || (this.$route.name == "EventLink")) {
        //
        } else if (!this.logged && !this.isGuest && this.$route.meta.requiresLogin == true) {
            let uri_qrcode = this.$route.fullPath.split('?')[1];
            let params_qrcode = new URLSearchParams(uri_qrcode);
            let redirectpath = this.$route.path
            if (params_qrcode.get('award')) {
                redirectpath += '?award='+params_qrcode.get('award')
            }
            if (this.$route.name != "EmailConfirmation") {
                localStorage.setItem("redirectPath",redirectpath)
            }
            this.link("Home");
            this.modal_login_ = true;
        } else if (!this.email_verified && this.$route.meta.requiresEmail == true) {
            if (this.$route.name != "EmailConfirmation") {
                localStorage.setItem("redirectPath",this.$route.path)
                this.link("EmailConfirmation");
            }
        } else if (!this.age_verified && this.$route.meta.requiresAge == true) {
            if (this.$route.name != "Age") {
                this.link("Age");
            }
        } else if (this.logged && this.$route.meta.requiresLogin == false) {
            if (!this.access_logged.includes(this.$route.name)) {
                this.link("Map")
            }
        } else if (this.logged && this.switch.validate_user) {
            if (this.$route.name !== "Map"){
                this.link("Map");
            }
        } else if (this.age_verified && this.$route.name == "Age") {
            this.link("Map");
        }


        let ext = document.createElement("script");
        ext.setAttribute("src", this.$url + "js/ext.js");
        document.head.appendChild(ext);
        document.addEventListener("external", this.externalEventHandler);
        window.addEventListener(
            "message",
            (event) => {
                switch (event.data.message_type){
                    case "token":
                        try {
                            event.source.postMessage({
                                type: "token",
                                token:this.token,
                                lang:this.$i18n.locale,
                                eventName:this.switch.Nome_Aba,
                            }, "*");
                        } catch ({error}) {
                            console.log('token error');
                        }
                        break;
                    case "external":
                        this.externalEventHandler({detail:{data:event.data.data}});
                        break;
                    case "avia":
                        this.aviaHandler(event.data);
                    break;
                }
            },
            false,
        )
    },
    updated() {
        document.body.style = Object.entries(this.cssVars).map(_=>_.join(":")).join(";");
        this.updateTitle();
    },
    watch: {
        $route(to, from) {
            this.updateTitle();
            //console.log'watch => ', to.name, from.name);
            if (!this.logged && !this.isGuest && to.meta.requiresLogin == true) {
                console.log('caindo no redirect do app')
                let uri_qrcode = to.fullPath.split('?')[1];
                let params_qrcode = new URLSearchParams(uri_qrcode);
                if (params_qrcode.get('award')) {
                    this.update_reward_slug(params_qrcode.get('award'))
                }
                this.link("Home");
                this.modal_login_ = true;
            }

            switch (from.name) {
                case "Iframe":
                    //console.log'juligo Iframe from.name');
                    window.location.reload();

                    document.getElementById('iframe').remove();
                    this.chat = false;
                    break;
                // case 'Home':
                case 'Support':
                    try {
                    this.$zendesk.hide();
                    } catch(e) {e;}
                    break;
            }
            //console.log'from.to => ', to.name);
            switch (to.name) {
                case "EventMap":
                case "EventLink":
                    //console.log'reload() to.name');
                    window.location.reload();
                    break;
                case "Iframe":
                    this.chat = false;
                    break;
                // case 'Home':
                case 'Support':
                    try {
                    this.$zendesk.show();
                    } catch(e) {e;}
                    break;
            }
            if (this.chat_not_clear) {
                this.chat_not_clear = false;
            } else {
                this.chat_not_clear = false;
                this.chat_room = "";
                this.chat_owner = "";
            }

            this.iframe_temp = false;
            this.switch_avatar_new = false;
            this.bodyOverflow(false);
            this.modalsHandler();
            this.wizardHandler();
            this.aoVivoHandler();
            if (!this.email_verified && to.meta.requiresEmail == true) {
                if (this.$route.name != "EmailConfirmation") {
                    localStorage.setItem("redirectPath",to.fullPath)
                    this.link("EmailConfirmation");
                }
            } else if (!this.age_verified && to.meta.requiresAge == true) {
                if (to.name != "Age") {
                    this.link("Age");
                }
            } else if (this.logged && to.meta.requiresLogin == false) {
                if (!this.access_logged.includes(to.name)) {
                    this.link("Map");
                }
            } else if (this.logged && this.switch.validate_user) {
                if (to.name !== "Map"){
                    this.link("Map");
                }
            }
            //location.reload();


      //this.bodyOverflow(false);
      //this.modalsHandler();
    },
        windowWidth(windowWidth) {
            if (windowWidth < 1000) {
                this.tools = false;
            } else {
                this.tools = true;
            }
        },
        logoUrl() {
            return this.logoUrl;
        },
        // reward_slug() {
        //     if (this.reward_slug != '' && (this.logged || this.isGuest)) {
        //         this.getRewards()
        //     }
        // },
        logged() {
            if (this.logged && this.reward_slug) {
                this.getRewards()
            }
        },
        isGuest() {
            if (this.isGuest && this.reward_slug) {
                this.getRewards()
            }
        }
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/app.scss";

.mobileNotifications {
    animation: pulse 1s infinite;
    transform-origin: center;
}

@keyframes pulse {
    0% {
        transform: scale(0.8);
    }
    50% {
        transform: scale(1);
    }
    100% {
        transform: scale(0.8);
    }
}

.toolsMobile div {
    margin-top: 8px;
}

.toolsBackdrop {
    background-color: rgba(0, 0, 0, .8);
    display: block;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99999;
}

.text-nickname {
    text-decoration: underline;
    font-size: 12px !important;
}

#chat_owner {
    background-color: rgba(0, 0, 0, 0.7);
    box-sizing: border-box;
    color: white;
    font-family: "Roboto";
    font-size: 12px;
    right: 0;
    padding: 8px;
    position: absolute;
    text-transform: uppercase;
    top: 130px;
}

.aovivo {
    background: #d91a32 !important;
    color: white !important;
    right: 245px !important;
    animation: aovivo 3s infinite alternate;
}

.aovivo p:hover {
    color: white !important;
}

@keyframes aovivo {
    0% {
        box-shadow: none;
    }
    33% {
        box-shadow: 0 0 7px 4px #d91a32;
    }
    100% {
        box-shadow: none;
    }
}

@keyframes aovivo_menor {
    0% {
        box-shadow: none;
    }
    33% {
        box-shadow: 0 0 4px 2px #d91a32;
    }
    100% {
        box-shadow: none;
    }
}

#play-pause-fullscreen {
    bottom: 90px;
    right: 10px;
    position: fixed;
}

#play-pause-fullscreen li {
    box-sizing: border-box;
    list-style: none;
    padding: 0 0 5px 0;
}

#play-pause-fullscreen img {
    filter: grayscale(1) invert(1);
    width: 40px;
}

@media screen and (max-width: 800px) {
    /*#iframe_temp
      {
          left: 10px !important;
          width: calc(100% - 20px) !important;
      }*/
    .aovivo {
        top: 360px;
        right: 0 !important;
    }
}

#webcam-photo {
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    display: none;
    font-family: "Roboto";
    font-size: 12px;
    height: 100%;
    left: 0;
    letter-spacing: 2px;
    position: fixed;
    top: 0;
    width: 100%;
}

#webcam-photo > #webcam-photo-content {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    display: block;
    height: auto;
    margin: 100px auto;
    position: relative;
    text-align: left;
    width: 522px;
}

#webcam-photo-header {
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 8px 8px 0px 0px;
    box-sizing: border-box;
    display: block;
    height: 57px;
    padding: 22px 15px;
    width: 100%;
}

#webcam-photo > #webcam-photo-content > #webcam-photo-video {
    background-color: black;
    background-image: url("../public/assets/img/webcam/icon_photo.png");
    background-repeat: no-repeat;

    background-position: center;
    border-radius: 8px;
    margin-left: 15px;
    margin-top: 15px;
    width: calc(100% - 30px);
    height: 278px;
}

#webcam-photo > #webcam-photo-content > #webcam-photo-canvas {
    border-radius: 8px;
    height: 278px;
    left: 0;
    margin-left: 15px;
    margin-top: 72px;
    position: absolute;
    top: 0;

    /*width: calc(100% - 30px);*/

    height: 278px;
    width: calc(100% - 30px);
    object-fit: cover;
    object-position: center;
}

#pointsIsMobile {
    position: absolute;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: row;
    top: 20px;
    right: 5px;
}

#pointsIsMobile p {
    margin: 0;
    padding: 0.5rem;
}

#pointsIsMobile #point {
    color: var(--buttons_color);
    min-width: 70px;
    margin-right: 10px;
    padding: 0 5px;
    border-radius: 5px;
    background-color: #fff;
    border: 1px solid var(--buttons_color);
}

#pointsIsMobile #coin {
    color: #fff;
    margin-right: 10px;
    padding: 0 5px;
    border-radius: 5px;
    min-width: 70px;
    background-color: var(--buttons_color);
    border: 1px solid var(--buttons_color);
}

#webcam-photo-discard {
    display: none;
    left: 25px;
    position: absolute;
    top: 75px;
}

#webcam-photo-save {
    display: none;
}

#webcam-photo .fr {
    float: right;
}

#webcam-btns {
    display: block;
    text-align: center;
}
.vs__search{
    padding: 0!important;
    margin: 0!important;
    width: 1px;
    height: 1px;
    position: absolute;
}
.vs__actions{
    display: none!important;
}
.v-select{
    padding: 7px;
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
}
.vs__selected{
    padding: 1px 0 0 0;
    margin: 0;
    border: none;
    position: relative!important;
}
.vs__dropdown-toggle{
    background-color: var(--multi_language_background);
    border-color: var(--buttons_color);
    padding: 0;
    border: none;
}
.vs__dropdown-menu{
    min-width: 32px;
    border-color: var(--buttons_color);
    margin-left: -1px;
}
.vs__dropdown-option {
    padding: 0;
    justify-content: center;
    display: flex;
    margin-top: 5px;
}
.vs__selected-options{
    padding: 0;
}
.vs--open{
    padding: 7px;
    border: 1px solid var(--buttons_color);
    border-radius: 4px 4px 0 0;
}

.add_quasar .column, .add_quasar .flex, .add_quasar .row {
    justify-content: center;
}

.add_quasar .q-focus-helper {
    width: 0;
}

.add_quasar .q-item-type {
    width:462px;
}

.add_quasar .q-avatar {
    width: .5em;
}

.q-expansion-item.q-item-type.q-expansion-item--collapsed.q-expansion-item--standard {
    width: 450px;
}
.q-expansion-item.q-item-type.q-expansion-item--expanded.q-expansion-item--standard {
    width: 450px;
}
.add_quasar .column, .add_quasar .flex, .add_quasar .row {
    justify-content: center;
}
/*----- loader -----*/
/*
    #loader
    {
        background-color: rgba(0, 0, 0, .8);
        display         : none;
        height          : 100%;
        left            : 0;
        position        : fixed;
        top             : 0;
        width           : 100%;
        z-index         : 99999;
    }
    #loader-ani
    {
        -webkit-animation: spin 2s linear infinite;
        animation        : spin 2s linear infinite;
        border           : 6px solid #f5f5f5;
        border-radius    : 50%;
        border-top       : 6px solid #13b5eb;
        height           : 40px;
        left             : 50%;
        margin-left      : -20px;
        margin-top       : -20px;
        position         : fixed;
        top              : 50%;
        width            : 40px;
    }

    @media screen and (max-width: 399px) {
        #audioPlayers img{
            max-width: 35px;
        }
    }

    @media screen and (min-width: 400px) {
        #audioPlayers img{
            max-width: 45px;
        }
    }

    @media screen and (min-width: 800px){
        #audioPlayers img{
            max-width: 55px;
        }
    }

    @media (max-width: 1000px) {
        #pointsIsMobile {
            position: static;
        }
        #pointsIsMobile #coin {
            height: 35px;
        }
        #pointsIsMobile #point {
            height: 35px;
        }
    }

    @-webkit-keyframes spin
    {
        0%   { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin
    {
        0%   { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    */
/*----- \loader\ -----*/
</style>
